webpackJsonp([31],{

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToNonHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollToTop; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var async = function async(bundle) {
  return function (loc, cb) {
    bundle().then(function (module) {
      return cb(null, module.default);
    });
  };
};
var convertToNonHash = function convertToNonHash() {
  if (document.location.hash.startsWith('#/')) {
    var match = document.location.hash.match(/^#\/(.*)/i);
    if (match) {
      var pathname = [].concat(_toConsumableArray(match))[1];
      document.location.replace('/' + pathname);
    } else document.location.replace('/');
  }
};

var scrollToTop = function scrollToTop(prevState, nextState) {
  if (nextState.location.action !== 'POP') {
    window.scrollTo(0, 0);
  }
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(async, 'async', '/home/circleci/project/js/components/helpers/routerUtils.js');

  __REACT_HOT_LOADER__.register(convertToNonHash, 'convertToNonHash', '/home/circleci/project/js/components/helpers/routerUtils.js');

  __REACT_HOT_LOADER__.register(scrollToTop, 'scrollToTop', '/home/circleci/project/js/components/helpers/routerUtils.js');
}();

;

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_zelements_less__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_zelements_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_zelements_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ZInput = function (_React$Component) {
  _inherits(ZInput, _React$Component);

  function ZInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ZInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ZInput.__proto__ || Object.getPrototypeOf(ZInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: '',
      pristine: true,
      invalidOverride: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ZInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var self = this;
      this.refs.input.addEventListener('invalid', function (e) {
        self.setState({ pristine: false });
        e.preventDefault();
      });
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'setToDirty',
    value: function setToDirty() {
      this.setState({ pristine: false });
    }
  }, {
    key: 'resetToPristine',
    value: function resetToPristine() {
      this.setState({ pristine: true, value: '' });
      this.refs.input.value = '';
    }
  }, {
    key: 'invalidate',
    value: function invalidate() {
      this.setState({ invalidOverride: true });
    }
  }, {
    key: 'passCustomValidity',
    value: function passCustomValidity(str) {
      this.refs.input.setCustomValidity(str);
    }
  }, {
    key: '_onChange',
    value: function _onChange() {
      this.setState({ pristine: false, invalidOverride: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var containerClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(this.props.classNames, 'input-container');
      var errorFromValidator = Object.values(_extends({}, this.props.validators)).map(function (f) {
        return f(_this2.props.value);
      }).filter(function (v) {
        return v;
      })[0];
      var error = function () {
        if (_this2.state.pristine || !_this2.props.errorMessageVisible) return null;else if (_this2.props.customError) return _this2.props.customError;else if (_this2.refs.input && !_this2.refs.input.validity.valid) return _this2.props.error;else if (errorFromValidator) return errorFromValidator;else if (_this2.props.customErrorMarkup) return _this2.props.customErrorMarkup;
      }();
      var inputClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
        password: this.props.password,
        pristine: this.state.pristine,
        valid: !error,
        invalid: !!error
      });
      var inputProps = __WEBPACK_IMPORTED_MODULE_2_underscore___default.a.omit(this.props, 'valueLink', 'password', 'classNames', 'errorMessageVisible', 'customError', 'onChange', 'customErrorMarkup');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: containerClasses },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps, {
          ref: 'input',
          className: inputClasses,
          onChange: function onChange(e) {
            _this2._onChange();
            if (_this2.props.onChange) _this2.props.onChange(e);
          }
        })),
        error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'error-msg' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'error-img', src: __webpack_require__(433) }),
          error
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
      );
    }
  }]);

  return ZInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ZInput.propTypes = {
  classNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  password: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  errorMessageVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  customError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customErrorMarkup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  validators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};
ZInput.defaultProps = {
  validators: {},
  value: null
};



;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ZInput, 'ZInput', '/home/circleci/project/js/components/widgets/ZElements.js');
}();

;

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isPhDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getContactNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrencyClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLoyaltyGuideLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showAppSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showFooterCareers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showProfileZapcash; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(71);


function getContactNumbers() {
  return ["8423-9143", "7730-2059"];
}
function getLoyaltyGuideLink() {
  return "http://bit.ly/zaployalty101";
}

function getCurrencyClass() {
  switch (document.domain) {
    case __WEBPACK_IMPORTED_MODULE_0_config__["b" /* USA_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_0_config__["c" /* SG_HOST */]:
      return "currency-Dollar";
    case __WEBPACK_IMPORTED_MODULE_0_config__["d" /* MY_HOST */]:
      return "currency-Ringgit";
    case __WEBPACK_IMPORTED_MODULE_0_config__["e" /* VN_HOST */]:
      return "currency-Dong";
    default:
      return "currency-Peso";
  }
}

function isPhDomain() {
  return document.domain === __WEBPACK_IMPORTED_MODULE_0_config__["h" /* PH_HOST */];
}

function isUSADomain() {
  return document.domain === __WEBPACK_IMPORTED_MODULE_0_config__["b" /* USA_HOST */];
}

function isSGDomain() {
  return document.domain === __WEBPACK_IMPORTED_MODULE_0_config__["c" /* SG_HOST */];
}

function isMyDomain() {
  return document.domain === __WEBPACK_IMPORTED_MODULE_0_config__["d" /* MY_HOST */];
}

function isVnDomain() {
  return document.domain === __WEBPACK_IMPORTED_MODULE_0_config__["e" /* VN_HOST */];
}

function showAppSection() {
  return isPhDomain() || isUSADomain() || isSGDomain() || isMyDomain() || isVnDomain();
}

function showFooterCareers() {
  return isPhDomain();
}

function showProfileZapcash() {
  return isPhDomain();
}


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getContactNumbers, "getContactNumbers", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(getLoyaltyGuideLink, "getLoyaltyGuideLink", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(getCurrencyClass, "getCurrencyClass", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(isPhDomain, "isPhDomain", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(isUSADomain, "isUSADomain", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(isSGDomain, "isSGDomain", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(isMyDomain, "isMyDomain", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(isVnDomain, "isVnDomain", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(showAppSection, "showAppSection", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(showFooterCareers, "showFooterCareers", "/home/circleci/project/js/components/helpers/domainSettings.js");

  __REACT_HOT_LOADER__.register(showProfileZapcash, "showProfileZapcash", "/home/circleci/project/js/components/helpers/domainSettings.js");
}();

;

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Loader = function (_React$Component) {
  _inherits(Loader, _React$Component);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
  }

  _createClass(Loader, [{
    key: 'render',
    value: function render() {
      if (this.props.loading) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'loader-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'svg',
            { className: 'circle-loader progress', width: '40', height: '40' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '20', cy: '20', r: '15' })
          )
        );
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
    }
  }]);

  return Loader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Loader.propTypes = {
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
var _default = Loader;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Loader, 'Loader', '/home/circleci/project/js/components/widgets/Loader.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/widgets/Loader.js');
}();

;

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_routes_AppHomeRoute__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(36);





var Register = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1084));
});
var RegisterStep1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1085));
});
var RegisterStep2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1086));
});
var RegisterStep3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1087));
});

var RegisterRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Route */],
  { path: 'register', getComponent: Register, queries: __WEBPACK_IMPORTED_MODULE_2_routes_AppHomeRoute__["a" /* default */].queries },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["i" /* IndexRedirect */], { to: 'step1' }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Route */], { path: 'step1', getComponent: RegisterStep1 }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Route */], { path: 'step2', getComponent: RegisterStep2 }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Route */], { path: 'step3', getComponent: RegisterStep3 })
);

var _default = RegisterRoutes;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Register, 'Register', '/home/circleci/project/js/RegisterRoutes.js');

  __REACT_HOT_LOADER__.register(RegisterStep1, 'RegisterStep1', '/home/circleci/project/js/RegisterRoutes.js');

  __REACT_HOT_LOADER__.register(RegisterStep2, 'RegisterStep2', '/home/circleci/project/js/RegisterRoutes.js');

  __REACT_HOT_LOADER__.register(RegisterStep3, 'RegisterStep3', '/home/circleci/project/js/RegisterRoutes.js');

  __REACT_HOT_LOADER__.register(RegisterRoutes, 'RegisterRoutes', '/home/circleci/project/js/RegisterRoutes.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/RegisterRoutes.js');
}();

;

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_routes_ResetPinSessionRoute__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(36);





var ResetPassword = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1088));
});
var ResetPasswordStep1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1089));
});
var ResetPasswordStep2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1090));
});
var ResetPasswordStep4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1091));
});
var ResetPasswordStep5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1092));
});

var ResetPasswordRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Route */],
  {
    path: 'reset-password',
    getComponent: ResetPassword,
    queries: __WEBPACK_IMPORTED_MODULE_2_routes_ResetPinSessionRoute__["a" /* default */].queries
  },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["i" /* IndexRedirect */], { to: 'step1' }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Route */], { path: 'step1', getComponent: ResetPasswordStep1 }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Route */], { path: 'step2', getComponent: ResetPasswordStep2 }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Route */], { path: 'step3', getComponent: ResetPasswordStep4 }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Route */], { path: 'step4', getComponent: ResetPasswordStep5 })
);

var _default = ResetPasswordRoutes;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ResetPassword, 'ResetPassword', '/home/circleci/project/js/ResetPasswordRoutes.js');

  __REACT_HOT_LOADER__.register(ResetPasswordStep1, 'ResetPasswordStep1', '/home/circleci/project/js/ResetPasswordRoutes.js');

  __REACT_HOT_LOADER__.register(ResetPasswordStep2, 'ResetPasswordStep2', '/home/circleci/project/js/ResetPasswordRoutes.js');

  __REACT_HOT_LOADER__.register(ResetPasswordStep4, 'ResetPasswordStep4', '/home/circleci/project/js/ResetPasswordRoutes.js');

  __REACT_HOT_LOADER__.register(ResetPasswordStep5, 'ResetPasswordStep5', '/home/circleci/project/js/ResetPasswordRoutes.js');

  __REACT_HOT_LOADER__.register(ResetPasswordRoutes, 'ResetPasswordRoutes', '/home/circleci/project/js/ResetPasswordRoutes.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/ResetPasswordRoutes.js');
}();

;

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_widgets_Loader__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_widgets_TransactionList__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_domainSettings__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_helpers_utils__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mutations_UpdateProfilePictureMutation__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_dashboard_less__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_dashboard_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_dashboard_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Dashboard = function (_React$Component) {
  _inherits(Dashboard, _React$Component);

  function Dashboard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dashboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      updating: false
    }, _this.getImage = function () {
      var _this2;

      return (_this2 = _this).__getImage__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dashboard, [{
    key: '__getImage__REACT_HOT_LOADER__',
    value: function __getImage__REACT_HOT_LOADER__() {
      return this.__getImage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      var zapperId = viewer ? viewer.zapperId : null;
      if (!zapperId) {
        router.replace('/login');
      } else if (zapperId && !this.isCompleteProfile()) {
        router.replace('/profile');
      }
    }
  }, {
    key: 'onPictureSuccess',
    value: function onPictureSuccess(s) {
      this.setState({ updating: false });
      console.log('MUTATION SUCCESS', s);
    }
  }, {
    key: 'onPictureFailure',
    value: function onPictureFailure(e) {
      this.setState({ updating: false });
      console.log('MUTATION FAILED', e);
    }
  }, {
    key: '__getImage__REACT_HOT_LOADER__',
    value: function __getImage__REACT_HOT_LOADER__() {
      var _this3 = this;

      //e.target.value.length > 0 - checks if cancelled or not
      this.setState({ updating: true });

      var onSuccess = function onSuccess(s) {
        _this3.onPictureSuccess(s);
      };
      var onFailure = function onFailure(e) {
        _this3.onPictureFailure(e);
      };

      var mutation = new __WEBPACK_IMPORTED_MODULE_8_mutations_UpdateProfilePictureMutation__["a" /* default */]({
        profile: this.props.viewer.profile,
        file: this.refs.profilePic.files.item(0)
      });
      __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.Store.commitUpdate(mutation, { onSuccess: onSuccess, onFailure: onFailure });
    }
  }, {
    key: 'isCompleteProfile',
    value: function isCompleteProfile() {
      var viewer = this.props.viewer;
      var profile = viewer.profile;
      var email = viewer.auth ? viewer.auth.email : viewer.auth;
      if (email && profile.firstName && profile.lastName && profile.birthday && profile.gender && profile.locationId) {
        return true;
      }
      return false;
    }
  }, {
    key: 'renderBalance',
    value: function renderBalance(b, index) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { key: index, className: 'currency-value' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'currency' },
          b.node.name
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'value' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_helpers_utils__["c" /* Comatose */])(b.node.redeemable)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var profile = _extends({}, this.props.viewer.profile);
      var zapCashBalanceName = this.props.viewer.zapCashCurrencyBalance.name;
      var zapCashBalanceValue = this.props.viewer.zapCashCurrencyBalance.redeemable;
      var currencyBalances = this.props.viewer.currencyBalances.edges;
      var image = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'profile-pic' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
          className: 'image-picker',
          type: 'file',
          ref: 'profilePic',
          onChange: this.getImage,
          accept: 'image/*'
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'avatar', src: profile.image })
      );
      if (this.state.updating) {
        image = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'image-loader' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_widgets_Loader__["a" /* default */], { loading: true })
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { id: 'dashboard' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'offwhite-bg' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'banner-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'banner' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'section' },
              image,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'details' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'full-name' },
                  profile.firstName + ' ' + profile.lastName
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["g" /* Link */],
                  { className: 'link', to: '/profile' },
                  'Go to My profile'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'section wallet' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'details' },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_domainSettings__["b" /* showProfileZapcash */])() ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'zapcash currency-value' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'currency' },
                    zapCashBalanceName
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'value' },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_helpers_utils__["c" /* Comatose */])(zapCashBalanceValue)
                  )
                ) : null,
                currencyBalances.map(function (b, index) {
                  return _this4.renderBalance(b, index);
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["g" /* Link */],
                  { className: 'link', to: '/wallet' },
                  'See more'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'body-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'section-border' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'section-title' },
              'Recent Transactions'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_widgets_TransactionList__["a" /* default */], {
            transactions: this.props.viewer.transactions,
            seeMore: true
          })
        )
      );
    }
  }]);

  return Dashboard;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Dashboard.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    forceFetch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  }).isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    zapperId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    auth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      email: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }),
    profile: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      firstName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      lastName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      birthday: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      gender: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      streetAddress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      locationId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }),
    zapCashCurrencyBalance: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      redeemable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
    }),
    currencyBalances: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      edges: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        node: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
          id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          acceptingBranchesCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          pendingEarn: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          redeemable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          rawId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
        })
      }))
    }),
    transactions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      edges: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        node: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
          id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          rawId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          merchant: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
          }),
          branch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
          }),
          status: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          amount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          transactedAt: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          allotments: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            currency: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
              rawId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
              name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
            }).isRequired,
            earnAmount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            redeemAmount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
          })),
          type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          manualReason: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
        })
      }))
    })
  }).isRequired
};

var _default = __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.createContainer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router__["h" /* withRouter */])(Dashboard), {
  initialVariables: {
    currencyBalancesCount: 3
  },
  fragments: {
    viewer: function viewer() {
      return function () {
        return {
          children: [{
            fieldName: 'zapperId',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            children: [{
              fieldName: 'email',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'auth',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Auth'
          }, {
            children: [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isRequisite: true
              },
              type: 'ID'
            }, {
              fieldName: 'firstName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'lastName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'birthday',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'gender',
              kind: 'Field',
              metadata: {},
              type: 'Gender'
            }, {
              fieldName: 'locationId',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              calls: [{
                kind: 'Call',
                metadata: {},
                name: 'size',
                value: {
                  kind: 'CallValue',
                  callValue: '140x140'
                }
              }],
              fieldName: 'image',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }],
            fieldName: 'profile',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Profile'
          }, {
            children: [{
              fieldName: 'name',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'redeemable',
              kind: 'Field',
              metadata: {},
              type: 'BigDecimal'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'zapCashCurrencyBalance',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'CurrencyBalance'
          }, {
            calls: [{
              kind: 'Call',
              metadata: {},
              name: 'isZapCashIncluded',
              value: {
                kind: 'CallValue',
                callValue: false
              }
            }, {
              kind: 'Call',
              metadata: {
                type: 'Int'
              },
              name: 'first',
              value: {
                kind: 'CallVariable',
                callVariableName: 'currencyBalancesCount'
              }
            }],
            children: [{
              children: [{
                children: [{
                  fieldName: 'name',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }, {
                  fieldName: 'redeemable',
                  kind: 'Field',
                  metadata: {},
                  type: 'BigDecimal'
                }, {
                  fieldName: 'id',
                  kind: 'Field',
                  metadata: {
                    isGenerated: true,
                    isRequisite: true
                  },
                  type: 'ID'
                }],
                fieldName: 'node',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  inferredRootCallName: 'node',
                  inferredPrimaryKey: 'id',
                  isRequisite: true
                },
                type: 'CurrencyBalance'
              }, {
                fieldName: 'cursor',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'String'
              }],
              fieldName: 'edges',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isPlural: true
              },
              type: 'CurrencyBalanceEdge'
            }, {
              children: [{
                fieldName: 'hasNextPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }, {
                fieldName: 'hasPreviousPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }],
              fieldName: 'pageInfo',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isGenerated: true,
                isRequisite: true
              },
              type: 'PageInfo'
            }],
            fieldName: 'currencyBalances',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              isConnection: true
            },
            type: 'CurrencyBalanceConnection'
          }, {
            calls: [{
              kind: 'Call',
              metadata: {
                type: 'Int'
              },
              name: 'first',
              value: {
                kind: 'CallValue',
                callValue: 5
              }
            }],
            children: [{
              children: [{
                children: [{
                  fieldName: 'id',
                  kind: 'Field',
                  metadata: {
                    isRequisite: true
                  },
                  type: 'ID'
                }, {
                  fieldName: 'rawId',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }, {
                  children: [{
                    fieldName: 'name',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                      isGenerated: true,
                      isRequisite: true
                    },
                    type: 'ID'
                  }],
                  fieldName: 'merchant',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true,
                    inferredRootCallName: 'node',
                    inferredPrimaryKey: 'id'
                  },
                  type: 'Merchant'
                }, {
                  children: [{
                    fieldName: 'name',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                      isGenerated: true,
                      isRequisite: true
                    },
                    type: 'ID'
                  }],
                  fieldName: 'branch',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true,
                    inferredRootCallName: 'node',
                    inferredPrimaryKey: 'id'
                  },
                  type: 'Branch'
                }, {
                  fieldName: 'status',
                  kind: 'Field',
                  metadata: {},
                  type: 'TransactionStatus'
                }, {
                  fieldName: 'amount',
                  kind: 'Field',
                  metadata: {},
                  type: 'BigDecimal'
                }, {
                  fieldName: 'transactedAt',
                  kind: 'Field',
                  metadata: {},
                  type: 'Long'
                }, {
                  children: [{
                    children: [{
                      fieldName: 'rawId',
                      kind: 'Field',
                      metadata: {},
                      type: 'ID'
                    }, {
                      fieldName: 'name',
                      kind: 'Field',
                      metadata: {},
                      type: 'String'
                    }],
                    fieldName: 'currency',
                    kind: 'Field',
                    metadata: {
                      canHaveSubselections: true
                    },
                    type: 'Currency'
                  }, {
                    fieldName: 'earnAmount',
                    kind: 'Field',
                    metadata: {},
                    type: 'BigDecimal'
                  }, {
                    fieldName: 'redeemAmount',
                    kind: 'Field',
                    metadata: {},
                    type: 'BigDecimal'
                  }],
                  fieldName: 'pointsAllotments',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true,
                    isPlural: true
                  },
                  type: 'PointsAllotment'
                }, {
                  children: [{
                    fieldName: 'couponId',
                    kind: 'Field',
                    metadata: {},
                    type: 'Int'
                  }, {
                    fieldName: 'promotionName',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }, {
                    fieldName: 'earn',
                    kind: 'Field',
                    metadata: {},
                    type: 'Int'
                  }, {
                    fieldName: 'redeem',
                    kind: 'Field',
                    metadata: {},
                    type: 'Int'
                  }],
                  fieldName: 'couponAllotments',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true,
                    isPlural: true
                  },
                  type: 'CouponAllotment'
                }, {
                  fieldName: 'type',
                  kind: 'Field',
                  metadata: {},
                  type: 'TransactionType'
                }, {
                  fieldName: 'manualReason',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }],
                fieldName: 'node',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  inferredRootCallName: 'node',
                  inferredPrimaryKey: 'id',
                  isRequisite: true
                },
                type: 'Transaction'
              }, {
                fieldName: 'cursor',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'String'
              }],
              fieldName: 'edges',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isPlural: true
              },
              type: 'TransactionEdge'
            }, {
              children: [{
                fieldName: 'hasNextPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }, {
                fieldName: 'hasPreviousPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }],
              fieldName: 'pageInfo',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isGenerated: true,
                isRequisite: true
              },
              type: 'PageInfo'
            }],
            fieldName: 'transactions',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              isConnection: true
            },
            type: 'TransactionConnection'
          }],
          id: __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Dashboard_ViewerRelayQL',
          type: 'Viewer'
        };
      }();
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (_default);
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Dashboard, 'Dashboard', '/home/circleci/project/js/components/pages/Dashboard.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/pages/Dashboard.js');
}();

;

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_debounce_input__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_debounce_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_debounce_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_widgets_MerchantBanner__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_widgets_ZapCashBanner__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_widgets_Loader__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_merchants_less__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_merchants_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_merchants_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Merchants = function (_React$Component) {
  _inherits(Merchants, _React$Component);

  function Merchants() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Merchants);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Merchants.__proto__ || Object.getPrototypeOf(Merchants)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loadingItems: false,
      openSearch: false,
      subcategoryFilters: [],
      keyword: ''
    }, _this.handleScroll = function () {
      var _this2;

      return (_this2 = _this).__handleScroll__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Merchants, [{
    key: '__handleScroll__REACT_HOT_LOADER__',
    value: function __handleScroll__REACT_HOT_LOADER__() {
      return this.__handleScroll__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      var zapperId = viewer ? viewer.zapperId : null;
      if (zapperId && !this.isCompleteProfile()) {
        router.replace('/profile');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('hashchange', function (e) {
        return _this3.hashchange(e);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('hashchange', this.hashchange);
    }
  }, {
    key: 'setRedemptionCurrency',
    value: function setRedemptionCurrency(redemptionCurrencyId, bannerCurrencyId) {
      var _this4 = this;

      this.props.relay.setVariables({
        redemptionCurrencyId: redemptionCurrencyId,
        bannerCurrencyId: bannerCurrencyId
      }, function (e) {
        return _this4.loadCallback(e);
      });
    }
  }, {
    key: 'hashchange',
    value: function hashchange() {
      var currentRedemptionCurrency = this.props.relay.variables.redemptionCurrencyId || null;
      var newRedemptionCurrency = this.props.location.query.redemptionCurrencyId || null;
      var bannerCurrencyId = this.props.location.query.redemptionCurrencyId || '1';

      if (currentRedemptionCurrency !== newRedemptionCurrency) {
        this.setRedemptionCurrency(newRedemptionCurrency, bannerCurrencyId);
      }
    }
  }, {
    key: 'isCompleteProfile',
    value: function isCompleteProfile() {
      var viewer = this.props.viewer;
      var profile = viewer.profile;
      var email = viewer.auth ? viewer.auth.email : viewer.auth;
      if (email && profile.firstName && profile.lastName && profile.birthday && profile.gender && profile.locationId) {
        return true;
      }
      return false;
    }
  }, {
    key: '__handleScroll__REACT_HOT_LOADER__',
    value: function __handleScroll__REACT_HOT_LOADER__() {
      if (this.isParent()) {
        var maxFooterHeight = 572;
        var height = window.document.documentElement.scrollHeight;
        var position = maxFooterHeight + window.innerHeight * 2 + window.scrollY;
        if (position >= height && !this.state.loadingItems) {
          this.loadItems();
        }
      }
    }
  }, {
    key: 'handleSort',
    value: function handleSort(e) {
      var _this5 = this;

      this.props.relay.setVariables({
        sortBy: e.target.value
      }, function (e) {
        return _this5.loadCallback(e);
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      var _this6 = this;

      var value = e.target.value;

      this.setState({ keyword: value });
      this.props.relay.setVariables({
        keyword: value
      }, function (e) {
        return _this6.loadCallback(e);
      });
    }
  }, {
    key: 'loadItems',
    value: function loadItems() {
      var _this7 = this;

      this.props.relay.setVariables({
        count: this.props.relay.variables.count + 10
      }, function (e) {
        return _this7.loadCallback(e);
      });
    }
  }, {
    key: 'loadCallback',
    value: function loadCallback(e) {
      if (e.done) {
        this.setState({ loadingItems: false });
      } else {
        this.setState({ loadingItems: true });
      }
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch() {
      this.setState({ openSearch: !this.state.openSearch });
    }
  }, {
    key: 'isParent',
    value: function isParent() {
      var hasChildren = this.props.children;
      if (hasChildren) {
        return false;
      }
      return true;
    }
  }, {
    key: 'clickCategory',
    value: function clickCategory(key) {
      var value = this.state[key] ? !this.state[key] : true;
      this.setState(_defineProperty({}, key, value));
    }
  }, {
    key: 'clickSubcategory',
    value: function clickSubcategory(key) {
      this.state.subcategoryFilters.push(key);
      this.forceUpdate();
    }
  }, {
    key: 'clearSubcategoryFilter',
    value: function clearSubcategoryFilter(key) {
      var subcategoryFilters = this.state.subcategoryFilters;
      var keyIndex = subcategoryFilters.indexOf(key);
      subcategoryFilters.splice(keyIndex, 1);
      this.setState({ subcategoryFilters: subcategoryFilters });
    }
  }, {
    key: 'clearSubcategoryFilters',
    value: function clearSubcategoryFilters() {
      this.setState({ subcategoryFilters: [] });
    }
  }, {
    key: 'clearRedemptionCurrency',
    value: function clearRedemptionCurrency() {
      var _this8 = this;

      this.props.relay.setVariables({
        redemptionCurrencyId: null
      }, function (e) {
        return _this8.loadCallback(e);
      });
    }
  }, {
    key: 'renderMerchantBanner',
    value: function renderMerchantBanner(m) {
      var branchName = m.node.searchBranch ? m.node.searchBranch.name : m.node.branch.name;
      var branchAddress = m.node.searchBranch ? m.node.searchBranch.address : m.node.branch.address;
      var rankImage = m.node.activeRank ? m.node.activeRank.rank.image : null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_widgets_MerchantBanner__["a" /* default */], {
        key: m.node.rawId,
        nodeId: m.node.id,
        parent: true,
        merchantName: m.node.name,
        logo: m.node.image,
        location: branchName,
        address: branchAddress,
        cashBack: m.node.effectiveCashBackRate,
        categories: m.node.categories,
        hasRedeemableReward: m.node.hasRedeemableReward,
        isZapCashAccepted: m.node.isZapCashAccepted,
        isZapCashAwarded: m.node.isZapCashAwarded,
        rankImage: rankImage,
        branchCount: m.node.branchCount,
        spiel: m.node.spiel
      });
    }
  }, {
    key: 'renderCategory',
    value: function renderCategory(c) {
      var _this9 = this;

      var key = c.node.name + '-category';
      var expandClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()({ expand: this.state[key] });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: key, className: expandClass },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'category', onClick: function onClick() {
              return _this9.clickCategory(key);
            } },
          c.node.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'subcategories' },
          c.node.subcategories.map(function (s) {
            return _this9.renderSubCategory(s);
          })
        )
      );
    }
  }, {
    key: 'renderSubCategory',
    value: function renderSubCategory(key) {
      var _this10 = this;

      var keySubcategory = key + '-subcategory';
      var subCategoryClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('subcategory', {
        selected: this.state.subcategoryFilters.indexOf(key) > -1
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          key: keySubcategory,
          className: subCategoryClass,
          onClick: function onClick() {
            return _this10.clickSubcategory(key);
          }
        },
        key
      );
    }
  }, {
    key: 'renderSubcategoryFilter',
    value: function renderSubcategoryFilter(key) {
      var _this11 = this;

      var keyFilter = key + '-filter';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          key: keyFilter,
          className: 'filter',
          onClick: function onClick() {
            return _this11.clearSubcategoryFilter(key);
          }
        },
        key
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this12 = this;

      var currencyId = void 0,
          currencyName = void 0,
          currencyBalance = void 0;

      if (this.props.viewer.currencyBalance) {
        var c = this.props.viewer.currencyBalance;
        currencyName = c.name;
        currencyBalance = c.redeemable;
        currencyId = c.rawId;
      }

      var merchants = this.props.viewer.merchants.edges;

      var searchContainerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('search-container', {
        in: this.state.openSearch,
        logged: this.props.viewer.zapperId,
        'has-banner': currencyBalance > 0
      });
      var merchantContainerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()({
        down: this.state.openSearch,
        'has-banner': currencyBalance > 0
      });

      var sortClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('sort', { hide: this.state.openDrawer });

      var searchBtnClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('search-btn', {
        hide: this.state.openDrawer
      });

      if (this.isParent()) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: 'merchants-container', className: merchantContainerClass },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'offwhite-bg' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'section-border' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'section-title' },
              'Merchants'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_widgets_ZapCashBanner__["a" /* default */], {
            id: currencyId,
            currency: currencyName,
            balance: currencyBalance
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'merchants' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'filters' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'label' },
                  'SORT BY'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'select',
                  {
                    className: sortClass,
                    onChange: function onChange(e) {
                      return _this12.handleSort(e);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'ALPHABETICAL' },
                    'Alphabetical'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'HIGHEST_CASHBACK_RATE' },
                    'Highest Cashback'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'NEAREST_BRANCH' },
                    'Nearest Branch'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
                  className: searchBtnClass,
                  onClick: function onClick() {
                    return _this12.toggleSearch();
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: searchContainerClass },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_debounce_input__["DebounceInput"], {
                    className: 'search',
                    minLength: 3,
                    debounceTimeout: 300,
                    onChange: function onChange(value) {
                      return _this12.handleSearch(value);
                    },
                    placeholder: 'Search',
                    value: this.state.keyword
                  })
                )
              ),
              merchants.map(this.renderMerchantBanner),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_widgets_Loader__["a" /* default */], { loading: this.state.loadingItems })
            )
          )
        );
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, {
        zapperId: this.props.viewer.zapperId
      });
    }
  }]);

  return Merchants;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Merchants.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    setVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    variables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      redemptionCurrencyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })
  }).isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    zapperId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    auth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    profile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      firstName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      lastName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      birthday: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      gender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      streetAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      locationId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    currencyBalance: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      rawId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      redeemable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
    }),
    merchants: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      edges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          rawId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          spiel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          effectiveCashBackRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
          image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          hasRedeemableReward: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
          isZapCashAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
          isZapCashAwarded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
          categories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
          branchCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
          branch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
          }),
          searchBranch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
          }),
          activeRank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            rank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
              image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
            })
          })
        })
      }))
    })
  }).isRequired
};

var _default = __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.createContainer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router__["h" /* withRouter */])(Merchants), {
  initialVariables: {
    count: 10,
    sortBy: 'ALPHABETICAL',
    keyword: '',
    redemptionCurrencyId: null,
    bannerCurrencyId: '1'
  },
  fragments: {
    viewer: function viewer() {
      return function () {
        return {
          children: [{
            children: [{
              fieldName: 'email',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'auth',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Auth'
          }, {
            children: [{
              fieldName: 'firstName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'lastName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'birthday',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'gender',
              kind: 'Field',
              metadata: {},
              type: 'Gender'
            }, {
              fieldName: 'locationId',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              calls: [{
                kind: 'Call',
                metadata: {},
                name: 'size',
                value: {
                  kind: 'CallValue',
                  callValue: '140x140'
                }
              }],
              fieldName: 'image',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'profile',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Profile'
          }, {
            calls: [{
              kind: 'Call',
              metadata: {},
              name: 'id',
              value: {
                kind: 'CallVariable',
                callVariableName: 'bannerCurrencyId'
              }
            }],
            children: [{
              fieldName: 'rawId',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'name',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'redeemable',
              kind: 'Field',
              metadata: {},
              type: 'BigDecimal'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'currencyBalance',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'CurrencyBalance'
          }, {
            calls: [{
              kind: 'Call',
              metadata: {
                type: 'MerchantSorting'
              },
              name: 'sortBy',
              value: {
                kind: 'CallVariable',
                callVariableName: 'sortBy'
              }
            }, {
              kind: 'Call',
              metadata: {},
              name: 'search',
              value: {
                kind: 'CallVariable',
                callVariableName: 'keyword'
              }
            }, {
              kind: 'Call',
              metadata: {
                type: 'Int'
              },
              name: 'first',
              value: {
                kind: 'CallVariable',
                callVariableName: 'count'
              }
            }, {
              kind: 'Call',
              metadata: {},
              name: 'redemptionCurrencyId',
              value: {
                kind: 'CallVariable',
                callVariableName: 'redemptionCurrencyId'
              }
            }],
            children: [{
              children: [{
                children: [{
                  fieldName: 'id',
                  kind: 'Field',
                  metadata: {
                    isRequisite: true
                  },
                  type: 'ID'
                }, {
                  fieldName: 'rawId',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }, {
                  fieldName: 'name',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }, {
                  fieldName: 'spiel',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }, {
                  fieldName: 'categories',
                  kind: 'Field',
                  metadata: {
                    isPlural: true
                  },
                  type: 'String'
                }, {
                  fieldName: 'isZapCashAccepted',
                  kind: 'Field',
                  metadata: {},
                  type: 'Boolean'
                }, {
                  fieldName: 'isZapCashAwarded',
                  kind: 'Field',
                  metadata: {},
                  type: 'Boolean'
                }, {
                  fieldName: 'hasRedeemableReward',
                  kind: 'Field',
                  metadata: {},
                  type: 'Boolean'
                }, {
                  fieldName: 'branchCount',
                  kind: 'Field',
                  metadata: {},
                  type: 'Int'
                }, {
                  fieldName: 'effectiveCashBackRate',
                  kind: 'Field',
                  metadata: {},
                  type: 'BigDecimal'
                }, {
                  calls: [{
                    kind: 'Call',
                    metadata: {},
                    name: 'size',
                    value: {
                      kind: 'CallValue',
                      callValue: '180x180'
                    }
                  }],
                  fieldName: 'image',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }, {
                  children: [{
                    fieldName: 'name',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }, {
                    fieldName: 'address',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                      isGenerated: true,
                      isRequisite: true
                    },
                    type: 'ID'
                  }],
                  fieldName: 'branch',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true,
                    inferredRootCallName: 'node',
                    inferredPrimaryKey: 'id'
                  },
                  type: 'Branch'
                }, {
                  alias: 'searchBranch',
                  calls: [{
                    kind: 'Call',
                    metadata: {},
                    name: 'search',
                    value: {
                      kind: 'CallVariable',
                      callVariableName: 'keyword'
                    }
                  }],
                  children: [{
                    fieldName: 'name',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }, {
                    fieldName: 'address',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                      isGenerated: true,
                      isRequisite: true
                    },
                    type: 'ID'
                  }],
                  fieldName: 'branch',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true,
                    inferredRootCallName: 'node',
                    inferredPrimaryKey: 'id'
                  },
                  type: 'Branch'
                }, {
                  children: [{
                    children: [{
                      fieldName: 'image',
                      kind: 'Field',
                      metadata: {},
                      type: 'String'
                    }, {
                      fieldName: 'id',
                      kind: 'Field',
                      metadata: {
                        isGenerated: true,
                        isRequisite: true
                      },
                      type: 'String'
                    }],
                    fieldName: 'rank',
                    kind: 'Field',
                    metadata: {
                      canHaveSubselections: true
                    },
                    type: 'Rank'
                  }],
                  fieldName: 'activeRank',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true
                  },
                  type: 'ActiveRank'
                }],
                fieldName: 'node',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  inferredRootCallName: 'node',
                  inferredPrimaryKey: 'id',
                  isRequisite: true
                },
                type: 'Merchant'
              }, {
                fieldName: 'cursor',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'String'
              }],
              fieldName: 'edges',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isPlural: true
              },
              type: 'MerchantEdge'
            }, {
              children: [{
                fieldName: 'hasNextPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }, {
                fieldName: 'hasPreviousPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }],
              fieldName: 'pageInfo',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isGenerated: true,
                isRequisite: true
              },
              type: 'PageInfo'
            }],
            fieldName: 'merchants',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              isConnection: true
            },
            type: 'MerchantConnection'
          }, {
            fieldName: 'zapperId',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }],
          id: __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Merchants_ViewerRelayQL',
          type: 'Viewer'
        };
      }();
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (_default);
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Merchants, 'Merchants', '/home/circleci/project/js/components/pages/Merchants.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/pages/Merchants.js');
}();

;

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_google_libphonenumber__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_google_libphonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_google_libphonenumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_underscore__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_widgets_Dialog__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_widgets_ZElements__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_widgets_DatePicker__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_helpers_utils__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mutations_UpdateProfileMutation__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mutations_ChangePinMutation__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mutations_ChangeEmailMutation__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mutations_ResendEmailVerificationMutation__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_datetime_css_react_datetime_css__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_datetime_css_react_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_datetime_css_react_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_profile_less__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_profile_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_profile_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var Profile = function (_React$Component) {
  _inherits(Profile, _React$Component);

  function Profile(props) {
    _classCallCheck(this, Profile);

    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));

    _this.onProfileSubmitClicked = function () {
      return _this.__onProfileSubmitClicked__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onNewPinSubmitClicked = function () {
      return _this.__onNewPinSubmitClicked__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.hideErrDialog = function () {
      return _this.__hideErrDialog__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.hideCompleteRegPopUp = function () {
      return _this.__hideCompleteRegPopUp__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.renderProfileBaseContainer = function () {
      return _this.__renderProfileBaseContainer__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.renderPinElements = function () {
      return _this.__renderPinElements__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.renderLeftContainer = function () {
      return _this.__renderLeftContainer__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.renderRightContainer = function () {
      return _this.__renderRightContainer__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    var _this$props$viewer = _this.props.viewer,
        profile = _this$props$viewer.profile,
        country = _this$props$viewer.country;

    _this.state = {
      gender: profile ? profile.gender : profile,
      location: profile ? profile.locationId : country.defaultLocationId,
      birthday: profile ? profile.birthday ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(profile.birthday, 'YYYY-MM-DD') : null : null,
      showEmailDialog: false,
      showCompleteRegDialog: true,

      savingProfileChanges: false,
      successSavingProfileChanges: false,
      profileSubmitted: false,

      savingPinChanges: false,

      pinError: null,

      pinSubmitted: false,
      pinButtonText: 'Save',

      emailError: null,

      resendButtonText: 'Resend',
      resendEmailErrCode: null,
      oldPin: '',
      newPin: '',
      confirmPin: ''
    };
    _this.handleChange = __WEBPACK_IMPORTED_MODULE_11_components_helpers_utils__["a" /* handleChange */].bind(_this);
    _this.onGenderChanged = _this.onGenderChanged.bind(_this);
    _this.onRegionChanged = _this.onRegionChanged.bind(_this);
    _this.handleProfileSubmit = _this.handleProfileSubmit.bind(_this);
    _this.handlePinSubmit = _this.handlePinSubmit.bind(_this);
    _this.handleEditEmailSubmit = _this.handleEditEmailSubmit.bind(_this);
    _this.resendEmailVerification = _this.resendEmailVerification.bind(_this);
    _this.hideEmailDialog = _this.hideEmailDialog.bind(_this);
    _this.showEmailDialog = _this.showEmailDialog.bind(_this);
    return _this;
  }

  _createClass(Profile, [{
    key: '__renderRightContainer__REACT_HOT_LOADER__',
    value: function __renderRightContainer__REACT_HOT_LOADER__() {
      return this.__renderRightContainer__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__renderLeftContainer__REACT_HOT_LOADER__',
    value: function __renderLeftContainer__REACT_HOT_LOADER__() {
      return this.__renderLeftContainer__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__renderPinElements__REACT_HOT_LOADER__',
    value: function __renderPinElements__REACT_HOT_LOADER__() {
      return this.__renderPinElements__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__renderProfileBaseContainer__REACT_HOT_LOADER__',
    value: function __renderProfileBaseContainer__REACT_HOT_LOADER__() {
      return this.__renderProfileBaseContainer__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__hideCompleteRegPopUp__REACT_HOT_LOADER__',
    value: function __hideCompleteRegPopUp__REACT_HOT_LOADER__() {
      return this.__hideCompleteRegPopUp__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__hideErrDialog__REACT_HOT_LOADER__',
    value: function __hideErrDialog__REACT_HOT_LOADER__() {
      return this.__hideErrDialog__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNewPinSubmitClicked__REACT_HOT_LOADER__',
    value: function __onNewPinSubmitClicked__REACT_HOT_LOADER__() {
      return this.__onNewPinSubmitClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProfileSubmitClicked__REACT_HOT_LOADER__',
    value: function __onProfileSubmitClicked__REACT_HOT_LOADER__() {
      return this.__onProfileSubmitClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      var zapperId = viewer ? viewer.zapperId : null;
      if (!zapperId) {
        router.replace('/login');
      }

      var profile = this.props.viewer.profile;
      var country = this.props.viewer.country;
      var regions = country.regions;

      var location = profile.locationId ? profile.locationId : country.defaultLocationId;

      regions.forEach(function (v) {
        if (location === v.locationId) {
          _this2.setState({ region: v, location: v.locationId });
          return;
        }
        v.cities.forEach(function (vv) {
          if (location === vv.locationId) {
            _this2.setState({ region: v, location: vv.locationId });
            return;
          }
        });
      });
    }

    /*
      onChange handlers
    */

  }, {
    key: 'onGenderChanged',
    value: function onGenderChanged(e) {
      this.handleChange(e, function (value) {
        return value.toUpperCase();
      });
    }
  }, {
    key: 'onRegionChanged',
    value: function onRegionChanged(e) {
      var regions = this.props.viewer.country.regions;
      var region = regions.find(function (r) {
        return r.locationId === e.target.value;
      });
      this.setState({ location: e.target.value });
      this.setState({ region: region });
    }
  }, {
    key: 'onBirthdayChange',
    value: function onBirthdayChange(e) {
      this.setState({ birthday: e });
    }
  }, {
    key: 'onEditEmailSuccess',
    value: function onEditEmailSuccess() {
      this.hideEmailDialog();
    }
  }, {
    key: 'onEditEmailFailure',
    value: function onEditEmailFailure(e) {
      var str = JSON.stringify(e.getError());
      var response = JSON.parse(str);
      var errArr = response.source.errors;

      var errorObj = __WEBPACK_IMPORTED_MODULE_6_underscore___default.a.first(errArr);

      if (errorObj && errorObj.error) {
        this.setState({ emailError: { code: errorObj.error.code, errorType: errorObj.error.type, data: errorObj.error.data } });
      } else {
        this.setState({ emailError: { code: 500 } });
      }
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      var _this3 = this;

      this.setState({
        savingProfileChanges: false,
        successSavingProfileChanges: true
      });

      setTimeout(function () {
        _this3.setState({ successSavingProfileChanges: false });
      }, 3000);
    }
  }, {
    key: 'onFailure',
    value: function onFailure() {
      this.setState({
        savingProfileChanges: false,
        successSavingProfileChanges: false
      });
    }
  }, {
    key: '__onProfileSubmitClicked__REACT_HOT_LOADER__',
    value: function __onProfileSubmitClicked__REACT_HOT_LOADER__() {
      this.setState({ profileSubmitted: true });
    }
  }, {
    key: '__onNewPinSubmitClicked__REACT_HOT_LOADER__',
    value: function __onNewPinSubmitClicked__REACT_HOT_LOADER__() {
      this.setState({ pinSubmitted: true });
    }
  }, {
    key: 'onPinSuccess',
    value: function onPinSuccess() {
      var _this4 = this;

      this.resetPinForm();
      this.setState({
        savingPinChanges: false,
        pinError: null,
        pinButtonText: 'PIN Saved',
        pinSubmitted: false
      });
      setTimeout(function () {
        _this4.setState({ pinButtonText: 'Save' });
      }, 3000);
    }
  }, {
    key: 'onPinFailure',
    value: function onPinFailure(e) {
      var str = JSON.stringify(e.getError());
      var response = JSON.parse(str);
      var errArr = response.source.errors;

      var errorObj = __WEBPACK_IMPORTED_MODULE_6_underscore___default.a.first(errArr);

      if (errorObj && errorObj.error) {
        var errCode = errorObj.error.code;
        this.setPinErrorCode({ code: errCode, errorType: errorObj.error.type, data: errorObj.error.data });
      } else {
        this.setPinErrorCode({ code: 500 });
      }
    }
  }, {
    key: 'setPinErrorCode',
    value: function setPinErrorCode(errJson) {
      this.setState({
        savingPinChanges: false,
        pinError: errJson,
        pinButtonText: 'Save',
        pinSubmitted: false
      });
    }
  }, {
    key: 'getPinErrorMessage',
    value: function getPinErrorMessage(jsonErr) {
      var pinErrorMessage = '';
      if (jsonErr.errorType && jsonErr.errorType == 'InvalidPin') {
        var triesLeft = jsonErr.data && jsonErr.data.attemptsLeft ? jsonErr.data.attemptsLeft + ' tries left.' : '';
        pinErrorMessage = 'Invalid PIN. ' + triesLeft;
      } else if (jsonErr.errorType && jsonErr.errorType == 'AccountLocked') {
        var formattedDate = jsonErr.data && jsonErr.data.lockedUntil ? ' after ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_components_helpers_utils__["b" /* DateTimeFormat */])(jsonErr.data.lockedUntil) : '';
        pinErrorMessage = 'Account is locked. Please try again' + formattedDate + '.';
      }
      return pinErrorMessage;
    }

    /*
      Form Submission
    */

  }, {
    key: 'handleProfileSubmit',
    value: function handleProfileSubmit(e) {
      var _this5 = this;

      e.preventDefault();
      var refs = this.refs;
      var address = refs.address.value;

      var profile = {
        id: this.props.viewer.profile.id,
        firstName: refs.firstName.value,
        lastName: refs.lastName.value,
        birthday: this.state.birthday ? this.state.birthday.format('YYYY-MM-DD') : null,
        gender: this.state.gender,
        locationId: this.state.location
      };
      if (address) {
        profile.address = address;
      }

      var onSuccess = function onSuccess() {
        _this5.onSuccess();
      };
      var onFailure = function onFailure() {
        _this5.onFailure();
      };

      this.setState({ savingProfileChanges: true });
      var mutation = new __WEBPACK_IMPORTED_MODULE_12_mutations_UpdateProfileMutation__["a" /* default */]({ profile: profile });
      __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.Store.commitUpdate(mutation, { onSuccess: onSuccess, onFailure: onFailure });
    }
  }, {
    key: 'requiredFormFieldClassNames',
    value: function requiredFormFieldClassNames(submitted) {
      return __WEBPACK_IMPORTED_MODULE_5_classnames___default()('form-field', {
        submitted: submitted
      });
    }
  }, {
    key: 'handlePinSubmit',
    value: function handlePinSubmit(e) {
      var _this6 = this;

      e.preventDefault();
      var changePin = {
        zapperId: this.props.viewer.zapperId,
        oldPin: this.state.oldPin,
        newPin: this.state.newPin
      };

      var onSuccess = function onSuccess() {
        _this6.onPinSuccess();
      };
      var onFailure = function onFailure(e) {
        _this6.onPinFailure(e);
      };
      this.setState({ savingPinChanges: true, pinButtonText: 'Saving' });
      var mutation = new __WEBPACK_IMPORTED_MODULE_13_mutations_ChangePinMutation__["a" /* default */](changePin);
      __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.Store.commitUpdate(mutation, { onSuccess: onSuccess, onFailure: onFailure });
    }
  }, {
    key: 'resetPinForm',
    value: function resetPinForm() {
      this.setState({
        newPin: '',
        confirmPin: '',
        oldPin: ''
      });
      this.refs.newPin.resetToPristine();
      this.refs.confirmPin.resetToPristine();
      this.refs.oldPin.resetToPristine();
    }
  }, {
    key: 'handleEditEmailSubmit',
    value: function handleEditEmailSubmit(e) {
      var _this7 = this;

      e.preventDefault();
      var email = e.target[1].value;
      var pin = e.target[2].value;

      var onSuccess = function onSuccess() {
        _this7.onEditEmailSuccess();
      };
      var onFailure = function onFailure(e) {
        _this7.onEditEmailFailure(e);
      };

      var mutation = new __WEBPACK_IMPORTED_MODULE_14_mutations_ChangeEmailMutation__["a" /* default */]({
        id: this.props.viewer.auth.id,
        email: email,
        pin: pin
      });
      __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.Store.commitUpdate(mutation, { onSuccess: onSuccess, onFailure: onFailure });
    }
  }, {
    key: 'showEmailDialog',
    value: function showEmailDialog() {
      this.setState({ showEmailDialog: true });
    }
  }, {
    key: 'hideEmailDialog',
    value: function hideEmailDialog() {
      this.setState({ showEmailDialog: false, emailError: null });
    }
  }, {
    key: 'resendEmailVerification',
    value: function resendEmailVerification() {
      var _this8 = this;

      var onSuccess = function onSuccess() {
        _this8.setState({ resendButtonText: 'Sent' });
        setTimeout(function () {
          _this8.setState({ resendButtonText: 'Resend' });
        }, 3000);
      };

      var onFailure = function onFailure(e) {
        var str = JSON.stringify(e.getError());
        var response = JSON.parse(str);
        var errArr = response.source.errors;

        var errorObj = __WEBPACK_IMPORTED_MODULE_6_underscore___default.a.first(errArr);

        if (errorObj && errorObj.error) {
          _this8.setState({ resendEmailErrCode: errorObj.error.code });
        } else {
          _this8.setState({ resendEmailErrCode: 500 });
        }
      };

      var mutation = new __WEBPACK_IMPORTED_MODULE_15_mutations_ResendEmailVerificationMutation__["a" /* default */]();
      __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.Store.commitUpdate(mutation, { onSuccess: onSuccess, onFailure: onFailure });
    }
  }, {
    key: '__hideErrDialog__REACT_HOT_LOADER__',
    value: function __hideErrDialog__REACT_HOT_LOADER__() {
      this.setState({ resendEmailErrCode: null });
    }
  }, {
    key: '__hideCompleteRegPopUp__REACT_HOT_LOADER__',
    value: function __hideCompleteRegPopUp__REACT_HOT_LOADER__() {
      this.setState({ showCompleteRegDialog: false });
    }
  }, {
    key: 'isCompleteProfile',
    value: function isCompleteProfile() {
      var viewer = this.props.viewer;
      var profile = viewer.profile;
      var auth = viewer.auth;

      if (auth.email && profile.firstName && profile.lastName && profile.birthday && profile.gender && profile.locationId) {
        return true;
      }
      return false;
    }

    /*
      Base Containers
    */

  }, {
    key: '__renderProfileBaseContainer__REACT_HOT_LOADER__',
    value: function __renderProfileBaseContainer__REACT_HOT_LOADER__() {
      var submitButtonClassNames = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('button', {
        saving: this.state.savingProfileChanges
      });
      var enableFieldset = this.state.savingProfileChanges ? 'disabled' : '';

      var submitButtonText = void 0;
      if (this.state.savingProfileChanges) {
        submitButtonText = 'Saving';
      } else if (!this.state.savingProfileChanges && this.state.successSavingProfileChanges) {
        submitButtonText = 'Changes Saved';
      } else {
        submitButtonText = 'Save';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'profile-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: 'form', onSubmit: this.handleProfileSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { disabled: enableFieldset },
            this.renderLeftContainer(),
            this.renderRightContainer(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'button-container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                className: submitButtonClassNames,
                type: 'submit',
                value: submitButtonText,
                onClick: this.onProfileSubmitClicked
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderPinBaseContainer',
    value: function renderPinBaseContainer() {
      var submitButtonClassNames = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('button', {
        saving: this.state.savingPinChanges
      });

      var enableFieldset = this.state.savingPinChanges ? 'disabled' : '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'change-pin-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          {
            className: 'form',
            onSubmit: this.handlePinSubmit,
            autoComplete: 'off'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { disabled: enableFieldset },
            this.renderNewPinContainer(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'button-container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                className: submitButtonClassNames,
                type: 'submit',
                value: this.state.pinButtonText,
                onClick: this.onNewPinSubmitClicked
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderBorder',
    value: function renderBorder(title) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'section-border' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-title' },
          title
        )
      );
    }

    /*
      Child Containers
    */

  }, {
    key: 'renderNewPinContainer',
    value: function renderNewPinContainer() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'new-pin-form' },
        this.renderPinElements()
      );
    }
  }, {
    key: '__renderPinElements__REACT_HOT_LOADER__',
    value: function __renderPinElements__REACT_HOT_LOADER__() {
      var _this9 = this;

      var refs = this.refs;
      if (refs.confirmPin && this.state.newPin !== this.state.confirmPin) {
        refs.confirmPin.passCustomValidity('Pin must match');
      } else if (refs.confirmPin) {
        refs.confirmPin.passCustomValidity('');
      }

      var cond = this.state.pinError;

      var pinErrorMessage = cond ? this.getPinErrorMessage(cond) : '';

      var formatError = 'PIN must be exactly 6 digits';
      var fields = [{
        name: 'oldPin',
        label: 'Current PIN',
        ref: 'oldPin',
        errorMsg: formatError,
        customErrMsg: cond && cond.code === 401 ? pinErrorMessage : ''
      }, {
        name: 'newPin',
        label: 'New PIN',
        ref: 'newPin',
        errorMsg: formatError,
        customErrMsg: cond && cond === 400 ? 'PIN has invalid format. Please try again.' : ''
      }, {
        name: 'confirmPin',
        label: 'Confirm New PIN',
        ref: 'confirmPin',
        errorMsg: 'Please enter the same PIN as above',
        customErrMsg: cond && cond === 500 ? 'Unable to change PIN. Please try again.' : ''
      }];

      return fields.map(function (field) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-field', key: field.ref },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            field.label
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_widgets_ZElements__["a" /* ZInput */], {
            name: field.name,
            ref: field.ref,
            onChange: _this9.handleChange,
            value: _this9.state[field.name],
            label: field.label,
            password: true,
            type: 'tel',
            pattern: '\\d{6}',
            maxLength: '6',
            error: field.errorMsg,
            customError: field.customErrMsg,
            required: true,
            errorMessageVisible: true
          })
        );
      });
    }
  }, {
    key: '__renderLeftContainer__REACT_HOT_LOADER__',
    value: function __renderLeftContainer__REACT_HOT_LOADER__() {
      var profile = this.props.viewer.profile;
      var auth = this.props.viewer.auth;
      var mobileNumber = auth.mobile;
      var email = auth.email;
      var isEmailConfirmed = auth.isEmailConfirmed;
      var codeAlpha2 = this.props.viewer.country.codeAlpha2;
      var phoneUtil = __WEBPACK_IMPORTED_MODULE_4_google_libphonenumber__["PhoneNumberUtil"].getInstance();

      mobileNumber = '+' + mobileNumber;

      var phoneNumber = phoneUtil.parse(mobileNumber, '');
      var cc = phoneUtil.getRegionCodeForNumber(phoneNumber);

      if (cc === codeAlpha2) {
        var nationalNumber = phoneNumber.getNationalNumber().toString();

        if (!nationalNumber.startsWith('9')) {
          mobileNumber = '0' + nationalNumber;

          mobileNumber = mobileNumber.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3');
        } else {
          mobileNumber = phoneUtil.format(phoneNumber, __WEBPACK_IMPORTED_MODULE_4_google_libphonenumber__["PhoneNumberFormat"].NATIONAL);
        }
      } else {
        mobileNumber = phoneUtil.format(phoneNumber, __WEBPACK_IMPORTED_MODULE_4_google_libphonenumber__["PhoneNumberFormat"].INTERNATIONAL);
      }

      var confirmElement = void 0;
      if (!isEmailConfirmed) {
        var resendElement = this.renderResendElement();
        confirmElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'confirm' },
          'E-mail address is not yet verified. Click the link in your verification e-mail.',
          resendElement
        );
      }

      var emailElement = void 0;
      if (email) {
        emailElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'email-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'email', title: email },
            email
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'edit email-add', onClick: this.showEmailDialog },
            'Edit'
          )
        );
      } else {
        emailElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          className: 'form-input',
          onFocus: this.showEmailDialog,
          value: email
        });
      }

      var requiredFormFieldClassNames = this.requiredFormFieldClassNames(this.state.profileSubmitted);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'left-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-field' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Mobile Number'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'mobile-number-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'mobile-number' },
              mobileNumber
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router__["g" /* Link */],
              { className: 'edit mobile', to: '/contact' },
              'Contact Zap to Change'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-field' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Email Address'
          ),
          emailElement
        ),
        confirmElement,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: requiredFormFieldClassNames },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'First Name'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            className: 'form-input',
            type: 'text',
            ref: 'firstName',
            defaultValue: profile.firstName,
            title: 'First name is required',
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: requiredFormFieldClassNames },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Last Name'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            className: 'form-input',
            type: 'text',
            ref: 'lastName',
            defaultValue: profile.lastName,
            title: 'Last name is required',
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-field' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Address'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            className: 'form-input',
            type: 'text',
            ref: 'address',
            defaultValue: profile.streetAddress
          })
        )
      );
    }
  }, {
    key: '__renderRightContainer__REACT_HOT_LOADER__',
    value: function __renderRightContainer__REACT_HOT_LOADER__() {
      var _this10 = this;

      var profile = this.props.viewer.profile;
      var gender = profile.gender ? profile.gender.toLowerCase() : '';

      var requiredFormFieldClassNames = this.requiredFormFieldClassNames(this.state.profileSubmitted);
      var regions = this.props.viewer.country.regions;
      var cities = this.state.region ? this.state.region.cities : null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'right-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: requiredFormFieldClassNames },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Date of Birth'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_widgets_DatePicker__["a" /* default */], {
            name: 'birthday',
            value: this.state.birthday ? this.state.birthday : null,
            onChange: function onChange(e) {
              return _this10.onBirthdayChange(e);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: requiredFormFieldClassNames },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Gender'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            {
              name: 'gender',
              className: 'gender',
              onChange: this.onGenderChanged,
              defaultValue: gender,
              title: 'Gender is required',
              required: true
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'option',
              { value: '', disabled: true },
              'Gender'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'option',
              { value: 'male' },
              'Male'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'option',
              { value: 'female' },
              'Female'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: requiredFormFieldClassNames },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Region'
          ),
          this.renderRegionSelectField(profile, regions)
        ),
        this.state.region && this.state.region.cities.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: requiredFormFieldClassNames },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'City'
          ),
          this.renderCitySelectField(profile, cities)
        ) : null
      );
    }
  }, {
    key: 'renderRegionSelectField',
    value: function renderRegionSelectField(profile, regions) {
      regions.sort(function (a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
      var regionId = this.state.region ? this.state.region.locationId : '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'select',
        {
          className: 'location',
          name: 'location',
          onChange: this.onRegionChanged,
          defaultValue: regionId,
          title: 'Region is required',
          required: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { value: '', disabled: true },
          'Select a location'
        ),
        regions.map(function (region, i) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { key: i, value: region.locationId },
            region.name
          );
        })
      );
    }
  }, {
    key: 'renderCitySelectField',
    value: function renderCitySelectField(profile, cities) {
      cities.sort(function (a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });

      var city = this.state.location ? this.state.location : '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'select',
        {
          className: 'location',
          name: 'location',
          onChange: this.handleChange,
          defaultValue: city,
          title: 'City is required',
          required: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { value: '', disabled: true },
          'Select a location'
        ),
        cities.map(function (city, i) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { key: i, value: city.locationId },
            city.name
          );
        })
      );
    }
  }, {
    key: 'renderResendElement',
    value: function renderResendElement() {
      var condition = this.state.resendButtonText === 'Resend';
      var resendElementClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('edit', 'resend', {
        'resend-clickable': condition
      });
      var onResendClickFunc = condition ? this.resendEmailVerification : function () {};
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: resendElementClassName, onClick: onResendClickFunc },
        this.state.resendButtonText
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var zapperId = this.props.viewer ? this.props.viewer.zapperId : null;
      var auth = this.props.viewer ? this.props.viewer.auth : null;

      if (zapperId) {
        var dialog = void 0;
        if (this.state.showEmailDialog) {

          var pinErrorMessage = this.state.emailError ? this.getPinErrorMessage(this.state.emailError) : '';

          var errCode = this.state.emailError ? this.state.emailError.code : 0;

          var pinErr = errCode === 401 ? pinErrorMessage : '';
          pinErr = errCode === 500 ? 'Unable to change email at this time' : pinErr;
          var emailErr = errCode === 409 ? 'Email already in use' : '';

          dialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_widgets_Dialog__["a" /* default */], {
            type: 'update-email',
            email: auth.email,
            pinErr: pinErr,
            emailErr: emailErr,
            handleEditEmailSubmit: this.handleEditEmailSubmit,
            handleExit: this.hideEmailDialog
          });
        }
        if (!this.isCompleteProfile() && this.state.showCompleteRegDialog) {
          dialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_widgets_Dialog__["a" /* default */], { type: 'complete-reg', handleExit: this.hideCompleteRegPopUp });
        }

        if (this.state.resendEmailErrCode) {
          var message = void 0;
          switch (this.state.resendEmailErrCode) {
            case 403:
              message = 'Resend Count Exceeded';
              break;
            case 404:
              message = 'Email Verification Expired';
              break;
            default:
              //handles 500 and others
              message = 'Unable to Resend. Please try again later.';
              break;
          }

          dialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_widgets_Dialog__["a" /* default */], {
            type: 'error',
            handleExit: this.hideErrDialog,
            errTitle: 'Resend Verification Email Failed',
            errMessage: message
          });
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: 'profile' },
          this.renderBorder('Personal Information'),
          this.renderProfileBaseContainer(),
          this.renderBorder('Change Pin'),
          this.renderPinBaseContainer(),
          dialog
        );
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
    }
  }]);

  return Profile;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Profile.propTypes = {
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    zapperId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    auth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      mobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      isEmailConfirmed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
    }),
    profile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      firstName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      lastName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      birthday: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      gender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      streetAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      locationId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      codeAlpha2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      locationId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      defaultLocationId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      regions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        locationId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        cities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          locationId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
        }))
      }))
    })
  }).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var _default = __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.createContainer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router__["h" /* withRouter */])(Profile), {
  fragments: {
    viewer: function viewer() {
      return function () {
        return {
          children: [{
            fieldName: 'zapperId',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            children: [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isRequisite: true
              },
              type: 'ID'
            }, {
              fieldName: 'mobile',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'email',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'isEmailConfirmed',
              kind: 'Field',
              metadata: {},
              type: 'Boolean'
            }],
            fieldName: 'auth',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Auth'
          }, {
            children: [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isRequisite: true
              },
              type: 'ID'
            }, {
              fieldName: 'firstName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'lastName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'birthday',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'gender',
              kind: 'Field',
              metadata: {},
              type: 'Gender'
            }, {
              fieldName: 'streetAddress',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'locationId',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }],
            fieldName: 'profile',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Profile'
          }, {
            children: [{
              fieldName: 'locationId',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'defaultLocationId',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'codeAlpha2',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'name',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              children: [{
                fieldName: 'locationId',
                kind: 'Field',
                metadata: {},
                type: 'String'
              }, {
                fieldName: 'name',
                kind: 'Field',
                metadata: {},
                type: 'String'
              }, {
                children: [{
                  fieldName: 'locationId',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }, {
                  fieldName: 'name',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }],
                fieldName: 'cities',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  isPlural: true
                },
                type: 'City'
              }],
              fieldName: 'regions',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isPlural: true
              },
              type: 'Region'
            }],
            fieldName: 'country',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true
            },
            type: 'Country'
          }],
          id: __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Profile_ViewerRelayQL',
          type: 'Viewer'
        };
      }();
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Profile, 'Profile', '/home/circleci/project/js/components/pages/Profile.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/pages/Profile.js');
}();

;

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_widgets_MerchantWalletBanner__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_widgets_ZapCashBanner__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_helpers_utils__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_widgets_ZElements__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mutations_LinkTagMutation__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_wallet_less__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_wallet_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_wallet_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_wallet_memberships_less__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_wallet_memberships_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_wallet_memberships_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Wallet = function (_React$Component) {
  _inherits(Wallet, _React$Component);

  function Wallet(props) {
    _classCallCheck(this, Wallet);

    var _this = _possibleConstructorReturn(this, (Wallet.__proto__ || Object.getPrototypeOf(Wallet)).call(this, props));

    _this.tabClicked = function () {
      return _this.__tabClicked__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.renderMerchantWalletPoints = function () {
      return _this.__renderMerchantWalletPoints__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.renderTabs = function () {
      return _this.__renderTabs__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      currentTab: 'points',
      showAddForm: false,
      linkMessage: 'LINK',
      isBusy: false,
      zapCode: '',
      pin: '',
      showError: false,
      errorMessage: 'Unable to link tag'
    };
    _this.handleChange = __WEBPACK_IMPORTED_MODULE_7_components_helpers_utils__["a" /* handleChange */].bind(_this);
    return _this;
  }

  _createClass(Wallet, [{
    key: '__renderTabs__REACT_HOT_LOADER__',
    value: function __renderTabs__REACT_HOT_LOADER__() {
      return this.__renderTabs__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__renderMerchantWalletPoints__REACT_HOT_LOADER__',
    value: function __renderMerchantWalletPoints__REACT_HOT_LOADER__() {
      return this.__renderMerchantWalletPoints__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__tabClicked__REACT_HOT_LOADER__',
    value: function __tabClicked__REACT_HOT_LOADER__() {
      return this.__tabClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      var zapperId = viewer ? viewer.zapperId : null;
      if (!zapperId) {
        router.replace('/login');
      } else if (zapperId && !this.isCompleteProfile()) {
        router.replace('/profile');
      }
    }
  }, {
    key: 'onLinktagSuccess',
    value: function onLinktagSuccess() {
      var _this2 = this;

      this.props.relay.forceFetch({}, function (readyState) {
        if (readyState.done) {
          console.log('Relay store updated');
        }
      });

      this.setState({ linkMessage: 'LINK SUCCESSFUL', isBusy: false });
      this.popupid = setTimeout(function () {
        if (_this2.popupid !== null) {
          clearTimeout(_this2.popupid);
          _this2.popupid = null;
        }
        _this2.setState({
          linkMessage: 'LINK',
          showAddForm: false,
          zapCode: '',
          pin: ''
        });
        _this2.refs.zapCode.resetToPristine();
        _this2.refs.pin.resetToPristine();
      }, 5000);
    }
  }, {
    key: 'onLinkTagFailure',
    value: function onLinkTagFailure(e) {
      var errorMsg = e.getError().source.errors[0].error.code === 400 ? 'Invalid tag code/pin' : this.state.errorMessage;

      this.setState({
        errorMessage: errorMsg,
        showError: true,
        isBusy: false
      });
      this.refs.zapCode.invalidate();
      this.refs.pin.invalidate();
    }
  }, {
    key: 'isCompleteProfile',
    value: function isCompleteProfile() {
      var viewer = this.props.viewer;
      var profile = viewer.profile;
      var email = viewer.auth ? viewer.auth.email : viewer.auth;
      if (email && profile.firstName && profile.lastName && profile.birthday && profile.gender && profile.locationId) {
        return true;
      }
      return false;
    }
  }, {
    key: '__tabClicked__REACT_HOT_LOADER__',
    value: function __tabClicked__REACT_HOT_LOADER__(e) {
      this.setState({ currentTab: e.target.id });
    }
  }, {
    key: 'fetchTabs',
    value: function fetchTabs() {
      return [{
        id: 'points'
      }, {
        id: 'memberships'
      }];
    }
  }, {
    key: 'formatDate',
    value: function formatDate(d) {
      var dd = d.getDate();
      var mm = d.getMonth() + 1;
      var yyyy = d.getFullYear();

      if (dd < 10) dd = '0' + dd;

      if (mm < 10) mm = '0' + mm;

      return mm + '/' + dd + '/' + yyyy;
    }
  }, {
    key: 'toggleAdder',
    value: function toggleAdder() {
      this.setState({ showAddForm: !this.state.showAddForm });
    }
  }, {
    key: 'handleAddSubmit',
    value: function handleAddSubmit(event) {
      var _this3 = this;

      event.preventDefault();

      var onSuccess = function onSuccess() {
        _this3.onLinktagSuccess();
      };
      var onFailure = function onFailure(e) {
        _this3.onLinkTagFailure(e);
      };
      var mutation = new __WEBPACK_IMPORTED_MODULE_9_mutations_LinkTagMutation__["a" /* default */]({
        zapCode: this.state.zapCode,
        pin: this.state.pin
      });
      __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.Store.commitUpdate(mutation, { onSuccess: onSuccess, onFailure: onFailure });
      this.setState({ isBusy: true, showError: false });
    }
  }, {
    key: '__renderMerchantWalletPoints__REACT_HOT_LOADER__',
    value: function __renderMerchantWalletPoints__REACT_HOT_LOADER__() {
      var pointsClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('points-container', {
        active: this.state.currentTab === 'points'
      });

      var zapCashBalance = this.props.viewer.zapCashCurrencyBalance ? this.props.viewer.zapCashCurrencyBalance.redeemable : 0;

      var balances = void 0;

      if (this.props.viewer.currencyBalances.edges.length > 0) {
        balances = this.props.viewer.currencyBalances.edges.map(this.renderMerchantWalletBanner);
      } else {
        balances = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'no-points' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'No Points'
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: pointsClassName },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-border wallet' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'section-title wallet' },
            'Points'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_widgets_ZapCashBanner__["a" /* default */], { zapCashBalance: zapCashBalance }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'points-banners-container' },
            balances
          )
        )
      );
    }
  }, {
    key: 'renderMerchantWalletBanner',
    value: function renderMerchantWalletBanner(balances) {
      var balance = balances.node;
      if (balance.redeemable > 0 || balance.pendingEarn > 0) {
        var link = '/merchants?redemptionCurrencyId=' + balance.rawId;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router__["g" /* Link */],
          {
            className: 'merchant-wallet-banner-container',
            to: link,
            key: balance.id
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_widgets_MerchantWalletBanner__["a" /* default */], {
            logo: balance.image,
            merchantName: balance.name,
            numBranches: balance.acceptingBranchesCount,
            clearedPoints: balance.redeemable,
            pendingPoints: balance.pendingEarn
          })
        );
      }
    }
  }, {
    key: 'renderMerchantWalletMemberships',
    value: function renderMerchantWalletMemberships() {
      var _this4 = this;

      var membershipsList = this.props.viewer.memberships.edges;
      var membershipClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()({
        active: this.state.currentTab === 'memberships'
      });

      var addFormClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()({
        'add-membership-form': true,
        down: this.state.showAddForm
      });

      var errorClassNames = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('reset-error', {
        hide: !this.state.showError
      });

      var memberships = void 0;
      if (membershipsList.length > 0) {
        memberships = membershipsList.map(function (membership) {
          var membershipImage = membership.node.image;

          var memKey = membership.node.id;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'membership-block-container', key: memKey },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'membership', key: memKey },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'card-image-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'card-image', src: membershipImage })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'card-info' },
                membership.node.tag ? _this4.renderMembershipInfoBlock('Card Number:', membership.node.tag.code) : null,
                membership.node.activeRank ? _this4.renderMembershipInfoBlock('Rank:', membership.node.activeRank.rank.name) : null,
                membership.node.activeRank ? _this4.renderMembershipInfoBlock('Valid Until:', _this4.formatDate(new Date(membership.node.activeRank.expiry))) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                  className: 'rank-img',
                  src: membership.node.activeRank ? membership.node.activeRank.rank.image : null
                })
              )
            )
          );
        });
      } else {
        memberships = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'no-memberships' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'No Memberships'
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'wallet-memberships', className: membershipClassName },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-border wallet' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'section-title wallet' },
            'Membership'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'membership-adder' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { onClick: function onClick() {
                return _this4.toggleAdder();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'logo' },
              '+'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              ' LINK TAG'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            {
              className: addFormClass,
              onSubmit: function onSubmit(event) {
                return _this4.handleAddSubmit(event);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_widgets_ZElements__["a" /* ZInput */], {
              required: true,
              type: 'text',
              ref: 'zapCode',
              name: 'zapCode',
              value: this.state.zapCode,
              onChange: this.handleChange,
              placeholder: 'Tag Code'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_widgets_ZElements__["a" /* ZInput */], {
              required: true,
              type: 'text',
              ref: 'pin',
              name: 'pin',
              value: this.state.pin,
              onChange: this.handleChange,
              placeholder: 'PIN'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { type: 'submit', disabled: this.state.isBusy },
              this.state.linkMessage
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: errorClassNames },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                this.state.errorMessage
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'memberships-container' },
          memberships
        )
      );
    }
  }, {
    key: 'renderMembershipInfoBlock',
    value: function renderMembershipInfoBlock(label, info) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'info-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'label' },
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'info' },
          info
        )
      );
    }
  }, {
    key: '__renderTabs__REACT_HOT_LOADER__',
    value: function __renderTabs__REACT_HOT_LOADER__(tab) {
      var itemClassNames = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('tab-item', {
        active: this.state.currentTab === tab.id
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: tab.id, className: 'tab' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: tab.id, className: itemClassNames, onClick: this.tabClicked },
          tab.id
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var tabs = this.fetchTabs();

      var points = this.renderMerchantWalletPoints();
      var membership = this.renderMerchantWalletMemberships();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'wallet' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'offwhite-bg' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'tabs' },
          tabs.map(this.renderTabs)
        ),
        points,
        membership
      );
    }
  }]);

  return Wallet;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Wallet.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    forceFetch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }).isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    zapperId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    auth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    profile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      firstName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      lastName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      birthday: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      gender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      streetAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      locationId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    zapCashCurrencyBalance: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      redeemable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
    }),
    currencyBalances: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      edges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          acceptingBranchesCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
          pendingEarn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
          redeemable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
          rawId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
        })
      }))
    }),
    memberships: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      edges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
          }),
          activeRank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            rank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
              id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
              name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
              image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
            }),
            expiry: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
          }),
          image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
        })
      }))
    })
  }).isRequired
};

var _default = __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.createContainer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router__["h" /* withRouter */])(Wallet), {
  initialVariables: {
    currencyBalancesCount: 10,
    membershipsCount: 10
  },
  fragments: {
    viewer: function viewer() {
      return function () {
        return {
          children: [{
            fieldName: 'zapperId',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            children: [{
              fieldName: 'email',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'auth',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Auth'
          }, {
            children: [{
              fieldName: 'firstName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'lastName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'birthday',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'gender',
              kind: 'Field',
              metadata: {},
              type: 'Gender'
            }, {
              fieldName: 'locationId',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              calls: [{
                kind: 'Call',
                metadata: {},
                name: 'size',
                value: {
                  kind: 'CallValue',
                  callValue: '140x140'
                }
              }],
              fieldName: 'image',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'profile',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Profile'
          }, {
            children: [{
              fieldName: 'name',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'redeemable',
              kind: 'Field',
              metadata: {},
              type: 'BigDecimal'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'zapCashCurrencyBalance',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'CurrencyBalance'
          }, {
            calls: [{
              kind: 'Call',
              metadata: {
                type: 'Int'
              },
              name: 'first',
              value: {
                kind: 'CallVariable',
                callVariableName: 'currencyBalancesCount'
              }
            }],
            children: [{
              children: [{
                children: [{
                  fieldName: 'id',
                  kind: 'Field',
                  metadata: {
                    isRequisite: true
                  },
                  type: 'ID'
                }, {
                  fieldName: 'name',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }, {
                  fieldName: 'image',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }, {
                  fieldName: 'acceptingBranchesCount',
                  kind: 'Field',
                  metadata: {},
                  type: 'Int'
                }, {
                  fieldName: 'pendingEarn',
                  kind: 'Field',
                  metadata: {},
                  type: 'BigDecimal'
                }, {
                  fieldName: 'redeemable',
                  kind: 'Field',
                  metadata: {},
                  type: 'BigDecimal'
                }, {
                  fieldName: 'rawId',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }],
                fieldName: 'node',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  inferredRootCallName: 'node',
                  inferredPrimaryKey: 'id',
                  isRequisite: true
                },
                type: 'CurrencyBalance'
              }, {
                fieldName: 'cursor',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'String'
              }],
              fieldName: 'edges',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isPlural: true
              },
              type: 'CurrencyBalanceEdge'
            }, {
              children: [{
                fieldName: 'hasNextPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }, {
                fieldName: 'hasPreviousPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }],
              fieldName: 'pageInfo',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isGenerated: true,
                isRequisite: true
              },
              type: 'PageInfo'
            }],
            fieldName: 'currencyBalances',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              isConnection: true
            },
            type: 'CurrencyBalanceConnection'
          }, {
            calls: [{
              kind: 'Call',
              metadata: {
                type: 'Int'
              },
              name: 'first',
              value: {
                kind: 'CallVariable',
                callVariableName: 'membershipsCount'
              }
            }],
            children: [{
              children: [{
                children: [{
                  fieldName: 'id',
                  kind: 'Field',
                  metadata: {
                    isRequisite: true
                  },
                  type: 'ID'
                }, {
                  children: [{
                    fieldName: 'code',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }, {
                    fieldName: 'image',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }],
                  fieldName: 'tag',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true
                  },
                  type: 'Tag'
                }, {
                  children: [{
                    children: [{
                      fieldName: 'id',
                      kind: 'Field',
                      metadata: {
                        isRequisite: true
                      },
                      type: 'String'
                    }, {
                      fieldName: 'name',
                      kind: 'Field',
                      metadata: {},
                      type: 'String'
                    }, {
                      fieldName: 'image',
                      kind: 'Field',
                      metadata: {},
                      type: 'String'
                    }],
                    fieldName: 'rank',
                    kind: 'Field',
                    metadata: {
                      canHaveSubselections: true
                    },
                    type: 'Rank'
                  }, {
                    fieldName: 'expiry',
                    kind: 'Field',
                    metadata: {},
                    type: 'Long'
                  }],
                  fieldName: 'activeRank',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true
                  },
                  type: 'ActiveRank'
                }, {
                  fieldName: 'image',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }],
                fieldName: 'node',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  inferredRootCallName: 'node',
                  inferredPrimaryKey: 'id',
                  isRequisite: true
                },
                type: 'Membership'
              }, {
                fieldName: 'cursor',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'String'
              }],
              fieldName: 'edges',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isPlural: true
              },
              type: 'MembershipEdge'
            }, {
              children: [{
                fieldName: 'hasNextPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }, {
                fieldName: 'hasPreviousPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }],
              fieldName: 'pageInfo',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isGenerated: true,
                isRequisite: true
              },
              type: 'PageInfo'
            }],
            fieldName: 'memberships',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              isConnection: true
            },
            type: 'MembershipConnection'
          }],
          id: __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Wallet_ViewerRelayQL',
          type: 'Viewer'
        };
      }();
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Wallet, 'Wallet', '/home/circleci/project/js/components/pages/Wallet.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/pages/Wallet.js');
}();

;

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_helpers_utils__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_zapcash_banner_less__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_zapcash_banner_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_zapcash_banner_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ZapCashBanner = function (_React$Component) {
  _inherits(ZapCashBanner, _React$Component);

  function ZapCashBanner() {
    _classCallCheck(this, ZapCashBanner);

    return _possibleConstructorReturn(this, (ZapCashBanner.__proto__ || Object.getPrototypeOf(ZapCashBanner)).apply(this, arguments));
  }

  _createClass(ZapCashBanner, [{
    key: 'render',
    value: function render() {
      var balance = this.props.balance ? this.props.balance : 0;
      var zapcashClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()([{ hide: balance === null || balance < 1 }, this.props.className]);

      var balanceClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()([{ zap: this.props.id === '1' }, 'balance']);

      var logo = this.props.id === '1' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(828) }) : null;

      var label = this.props.id === '1' ? 'Use your ZAPCash at stores with this sign on the door.' : 'Use your ' + this.props.currency + ' at these stores.';

      var balanceLabel = this.props.id === '1' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_components_helpers_utils__["c" /* Comatose */])(balance) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_components_helpers_utils__["c" /* Comatose */])(balance) + ' ' + this.props.currency;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'zapcash-banner', className: zapcashClass },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'zapcash-balance-container' },
          logo,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: balanceClass },
            balanceLabel
          )
        ),
        label
      );
    }
  }]);

  return ZapCashBanner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ZapCashBanner.propTypes = {
  balance: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currency: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var _default = ZapCashBanner;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ZapCashBanner, 'ZapCashBanner', '/home/circleci/project/js/components/widgets/ZapCashBanner.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/widgets/ZapCashBanner.js');
}();

;

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AppHomeRoute = function (_Relay$Route) {
  _inherits(AppHomeRoute, _Relay$Route);

  function AppHomeRoute() {
    _classCallCheck(this, AppHomeRoute);

    return _possibleConstructorReturn(this, (AppHomeRoute.__proto__ || Object.getPrototypeOf(AppHomeRoute)).apply(this, arguments));
  }

  return AppHomeRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.Route);

AppHomeRoute.routeName = 'AppHomeRoute';
AppHomeRoute.queries = {
  viewer: function viewer(Component) {
    return function (RQL_0) {
      return {
        children: [].concat.apply([], [__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__frag(RQL_0)]),
        fieldName: 'viewer',
        kind: 'Query',
        metadata: {},
        name: 'AppHomeRoute',
        type: 'Viewer'
      };
    }(Component.getFragment('viewer'));
  }
};
var _default = AppHomeRoute;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AppHomeRoute, 'AppHomeRoute', '/home/circleci/project/js/routes/AppHomeRoute.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/routes/AppHomeRoute.js');
}();

;

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_relay__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegisterRoutes__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResetPasswordRoutes__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MainRoutes__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_domainSettings__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_routerUtils__ = __webpack_require__(116);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Root = function (_React$Component) {
  _inherits(Root, _React$Component);

  function Root() {
    _classCallCheck(this, Root);

    return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
  }

  _createClass(Root, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: 'router-wrapper', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_helpers_domainSettings__["a" /* getCurrencyClass */])() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Router */],
            {
              history: __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* browserHistory */],
              render: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* applyRouterMiddleware */])(__WEBPACK_IMPORTED_MODULE_2_react_router_relay__["a" /* default */]),
              environment: __WEBPACK_IMPORTED_MODULE_3_react_relay_classic___default.a.Store
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */],
              {
                path: 'm',
                component: __WEBPACK_IMPORTED_MODULE_6__MainRoutes__["a" /* ParentRoute */],
                onChange: __WEBPACK_IMPORTED_MODULE_8__components_helpers_routerUtils__["b" /* scrollToTop */],
                render: function render(args) {
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__MainRoutes__["b" /* PageLoading */])(__WEBPACK_IMPORTED_MODULE_6__MainRoutes__["a" /* ParentRoute */], args);
                }
              },
              __WEBPACK_IMPORTED_MODULE_4__RegisterRoutes__["a" /* default */],
              __WEBPACK_IMPORTED_MODULE_5__ResetPasswordRoutes__["a" /* default */]
            ),
            __WEBPACK_IMPORTED_MODULE_6__MainRoutes__["c" /* default */]
          )
        )
      );
    }
  }]);

  return Root;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Root;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Root, 'Root', '/home/circleci/project/js/Root.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/Root.jsx');
}();

;

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__);


var theme = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__["createMuiTheme"])({
  palette: {
    primary: { main: "#212B36" },
    secondary: { main: "#FFFFFF" },
    tertiary: { main: "#BD311F" }
  },

  overrides: {
    MuiTypography: {
      h1: {
        fontSize: "40px",
        fontFamily: "manrope-bold-webfont",
        lineHeight: "48px"
      },
      h2: {
        fontFamily: "manrope-bold-webfont",
        fontSize: "20px"
      },
      body1: {
        fontSize: "16px",
        fontFamily: "manrope-semibold-webfont",
        lineHeight: "24px"
      }
    },
    MuiButton: {
      root: {
        fontFamily: "manrope-semibold-webfont",
        fontSize: "16px",
        padding: "16px 32px",
        borderRadius: "8px",
        textTransform: "none"
      },
      label: { fontFamily: "manrope-semibold-webfont", fontSize: "16px" },
      text: { fontFamily: "manrope-semibold-webfont", fontSize: "16px" },
      containedPrimary: {
        backgroundColor: "#BD311F",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "rgb(189, 49, 31)"
        }
      },
      containedSecondary: {
        backgroundColor: "#FFFFFF",
        color: "#BD311F",
        border: "1px solid #BD311F",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "rgb(253, 242, 242)"
        }
      }
    },
    MuiCssBaseline: {
      root: { fontFamily: "manrope-semibold-webfont" }
    }
  }
});

var _default = theme;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(theme, "theme", "/home/circleci/project/js/components/helpers/theme.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/helpers/theme.js");
}();

;

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_pages_Merchants__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_pages_Wallet__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_pages_Dashboard__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_pages_Profile__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Footer__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Header__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_index_less__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_config__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PhFooter__ = __webpack_require__(680);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App(props, context) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));

    _this.headerTransparentRoutes = ["/business"];
    _this.state = {
      headerBodyOffset: 0,
      isHeaderTransparent: _this.headerTransparentRoutes.includes(_this.props.location.pathname)
    };
    _this.headerBackgroundHandler = _this.headerBackgroundHandler.bind(_this);
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Decode entities in the URL
      // Sometimes a URL like #/foo#bar will be encoded as #/foo%23bar

      window.location.hash = window.decodeURIComponent(window.location.hash);
      var scrollToAnchor = function scrollToAnchor() {
        var hashParts = window.location.hash.split("#");
        if (hashParts.length > 2) {
          var hash = hashParts.slice(-1)[0];
          document.querySelector("#" + hash).scrollIntoView();
        }
      };
      scrollToAnchor();
      window.onhashchange = scrollToAnchor;
      this.onScrollListenerForHeader(this.props.location.pathname);
      window.addEventListener("resize", function () {
        _this2.onScrollListenerForHeader(_this2.props.location.pathname);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.onScrollListenerForHeader(nextProps.location.pathname);
    }
  }, {
    key: "onScrollListenerForHeader",
    value: function onScrollListenerForHeader(pathname) {
      window.removeEventListener("scroll", this.headerBackgroundHandler, false);
      if (this.headerTransparentRoutes.includes(pathname)) {
        this.setState({
          isHeaderTransparent: true
        });
        if (window.innerWidth <= 920) {
          window.addEventListener("scroll", this.headerBackgroundHandler, false);
        }
      } else this.setState({ isHeaderTransparent: false });
    }
  }, {
    key: "headerBackgroundHandler",
    value: function headerBackgroundHandler() {
      if (window.pageYOffset >= this.state.headerBodyOffset.top) {
        if (this.state.isHeaderTransparent) {
          this.setState({
            isHeaderTransparent: false
          });
        }
      } else if (!this.state.isHeaderTransparent) {
        this.setState({
          isHeaderTransparent: true
        });
      }
    }
  }, {
    key: "handleHeaderBodyOffSet",
    value: function handleHeaderBodyOffSet(ref) {
      var element = __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(ref);
      var bounding = element.getBoundingClientRect();
      this.setState({
        headerBodyOffset: {
          top: bounding.top + document.body.scrollTop,
          left: bounding.left + document.body.scrollLeft
        }
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      var _props = this.props,
          relay = _props.relay,
          router = _props.router;

      return __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
        type: "POST",
        url: "/api" + "/logout",
        contentType: "application/json; charset=UTF-8",
        dataType: "json",
        crossDomain: true,
        xhrFields: { withCredentials: true },
        data: JSON.stringify({})
      }).done(function () {
        relay.forceFetch({}, function (readyState) {
          if (readyState.done) router.push("/login");
        });
      }).fail(function () {
        console.log("logout failure");
      });
    }
  }, {
    key: "renderReactChildren",
    value: function renderReactChildren() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children, function (child) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          handleHeaderBodyOffSet: function handleHeaderBodyOffSet(ref) {
            return _this3.handleHeaderBodyOffSet(ref);
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var zapperId = this.props.viewer.zapperId ? this.props.viewer.zapperId : null;
      var firstName = this.props.viewer.profile ? this.props.viewer.profile.firstName : null;
      var image = this.props.viewer.profile ? this.props.viewer.profile.image : null;
      var mobileBodyWrapperClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()("mobile-body-wrapper", {
        "logged-in": firstName !== null
      });

      var hostname = window.location.hostname;


      var search = window.location.search; // ?header=hidden&footer=hidden
      var params = new URLSearchParams(search);
      // if no params
      var hasHeader = !(params.get('header') === 'hidden');
      var hasFooter = !(params.get('footer') === 'hidden');
      if (hasHeader && hasFooter) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { id: "container" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { id: "body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Header__["a" /* default */], {
              routes: this.props.routes,
              location: this.props.location,
              zapperId: zapperId,
              firstName: firstName,
              image: image,
              logout: function logout() {
                return _this4.logout();
              },
              isTransparent: this.state.isHeaderTransparent
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              this.renderReactChildren()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "footer-filler" })
          ),
          hostname === __WEBPACK_IMPORTED_MODULE_14_config__["h" /* PH_HOST */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PhFooter__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Footer__["a" /* default */], null)
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { id: "container" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { id: "body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              this.renderReactChildren()
            )
          )
        );
      }
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

App.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    push: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  }).isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    forceFetch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  }).isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    zapperId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    profile: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
      firstName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
      image: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
    })
  }).isRequired,
  routes: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    path: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })).isRequired,
  location: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var _default = __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.createContainer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router__["h" /* withRouter */])(App), {
  fragments: {
    viewer: function viewer() {
      return function (RQL_0, RQL_1, RQL_2, RQL_3) {
        return {
          children: [].concat.apply([], [{
            fieldName: "zapperId",
            kind: "Field",
            metadata: {},
            type: "String"
          }, {
            children: [{
              fieldName: "firstName",
              kind: "Field",
              metadata: {},
              type: "String"
            }, {
              calls: [{
                kind: "Call",
                metadata: {},
                name: "size",
                value: {
                  kind: "CallValue",
                  callValue: "40x40"
                }
              }],
              fieldName: "image",
              kind: "Field",
              metadata: {},
              type: "String"
            }, {
              fieldName: "id",
              kind: "Field",
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: "ID"
            }],
            fieldName: "profile",
            kind: "Field",
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: "node",
              inferredPrimaryKey: "id"
            },
            type: "Profile"
          }, __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.QL.__frag(RQL_0), __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.QL.__frag(RQL_1), __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.QL.__frag(RQL_2), __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.QL.__frag(RQL_3)]),
          id: __WEBPACK_IMPORTED_MODULE_2_react_relay_classic___default.a.QL.__id(),
          kind: "Fragment",
          metadata: {},
          name: "App_ViewerRelayQL",
          type: "Viewer"
        };
      }(__WEBPACK_IMPORTED_MODULE_7_components_pages_Merchants__["default"].getFragment("viewer"), __WEBPACK_IMPORTED_MODULE_8_components_pages_Wallet__["default"].getFragment("viewer"), __WEBPACK_IMPORTED_MODULE_9_components_pages_Dashboard__["default"].getFragment("viewer"), __WEBPACK_IMPORTED_MODULE_10_components_pages_Profile__["default"].getFragment("viewer"));
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(App, "App", "/home/circleci/project/js/components/App.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/App.js");
}();

;

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_merchant_banner_less__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_merchant_banner_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_merchant_banner_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MerchantBanner = function (_React$Component) {
  _inherits(MerchantBanner, _React$Component);

  function MerchantBanner() {
    _classCallCheck(this, MerchantBanner);

    return _possibleConstructorReturn(this, (MerchantBanner.__proto__ || Object.getPrototypeOf(MerchantBanner)).apply(this, arguments));
  }

  _createClass(MerchantBanner, [{
    key: 'toUrlFormat',
    value: function toUrlFormat(str) {
      return str.replace(/\W+/g, '-').toLowerCase();
    }
  }, {
    key: 'render',
    value: function render() {
      var merchantNameUrl = this.toUrlFormat(this.props.merchantName);
      var branchNameUrl = this.toUrlFormat(this.props.location);
      var merchantUrl = '/merchants/' + merchantNameUrl + '/' + branchNameUrl + '/' + this.props.nodeId;

      var bannerClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('merchant-banner', this.props.categories, {
        authenticated: this.props.authenticated
      });

      var isZapCashAcceptedClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
        'zap-cash badge': this.props.isZapCashAccepted
      });

      var hasRedeemableRewardClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
        'reward badge': this.props.hasRedeemableReward
      });

      var branchesClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('branches', {
        hidden: this.props.branchCount === 1 || !this.props.parent
      });

      var addressClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('address', { full: !this.props.parent });

      var rankImage = this.props.rankImage ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'rank', src: this.props.rankImage }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null);

      var hasSpiel = this.props.spiel !== null;
      var details = hasSpiel ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'spiel' },
        this.props.spiel
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'cashBack' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'b',
          null,
          this.props.cashBack,
          '%'
        ),
        ' ',
        this.props.isZapCashAwarded ? 'ZAPCASH' : 'STORE POINTS'
      );

      var openingHoursField = void 0;
      var telephoneNumberField = void 0;
      if (!this.props.parent) {
        openingHoursField = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'opening-hours' },
          this.props.openingHours
        );
        telephoneNumberField = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'telephone' },
          this.props.telephone,
          ' '
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
        { to: merchantUrl, className: bannerClasses },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'merchant' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'filler' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'logo', src: this.props.logo }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'info' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'name' },
              this.props.merchantName
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'location' },
              this.props.location
            ),
            openingHoursField,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: addressClasses },
              this.props.address
            ),
            telephoneNumberField
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'details' },
          details,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'badges' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: isZapCashAcceptedClasses }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: hasRedeemableRewardClasses }),
            rankImage
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: branchesClasses },
            this.props.branchCount,
            ' branches'
          )
        )
      );
    }
  }]);

  return MerchantBanner;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MerchantBanner.propTypes = {
  merchantName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  nodeId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  categories: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  authenticated: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isZapCashAccepted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  hasRedeemableReward: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  branchCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  parent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  rankImage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  openingHours: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  telephone: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  logo: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  address: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  cashBack: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  isZapCashAwarded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  spiel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
var _default = MerchantBanner;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MerchantBanner, 'MerchantBanner', '/home/circleci/project/js/components/widgets/MerchantBanner.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/widgets/MerchantBanner.js');
}();

;

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_helpers_utils__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_icons_TransactionZapCashIcon__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_icons_TransactionZapCardIcon__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_icons_TransactionCouponIcon__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_transaction_list_less__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_transaction_list_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_transaction_list_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var TransactionList = function (_React$Component) {
  _inherits(TransactionList, _React$Component);

  function TransactionList() {
    _classCallCheck(this, TransactionList);

    return _possibleConstructorReturn(this, (TransactionList.__proto__ || Object.getPrototypeOf(TransactionList)).apply(this, arguments));
  }

  _createClass(TransactionList, [{
    key: 'renderPointsAllotment',
    value: function renderPointsAllotment(a, type, manualReason) {
      var earn = void 0,
          redeem = void 0,
          icon = void 0;

      if (a.currency.rawId === '1') {
        icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'icon-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icons_TransactionZapCashIcon__["a" /* default */], null)
        );
      } else {
        icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'icon-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_icons_TransactionZapCardIcon__["a" /* default */], null)
        );
      }
      var isManual = type === 'ManualPoints' || type === 'ManualCoupon';

      if (a.earnAmount) {
        var action = isManual ? 'Added' + (manualReason ? ' - ' + manualReason : '') : 'Earned';
        var earnClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('earned', { zap: isManual });

        earn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: earnClass },
          icon,
          ' ',
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_components_helpers_utils__["c" /* Comatose */])(a.earnAmount),
          ' ',
          a.currency.name,
          ' ',
          action
        );
      }

      if (a.redeemAmount) {
        var _action = void 0,
            redeemClass = void 0;
        if (type === 'ExpiredPoints' && a.currency.rawId !== '1') {
          _action = 'Expired';
          redeemClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('expired', { zap: isManual });
        } else {
          _action = isManual ? 'Removed' + (manualReason ? ' - ' + manualReason : '') : 'Redeemed';

          redeemClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('redeemed', { zap: isManual });
        }
        redeem = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: redeemClass },
          icon,
          ' ',
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_components_helpers_utils__["c" /* Comatose */])(a.redeemAmount),
          ' ',
          a.currency.name,
          ' ',
          _action
        );
      }

      var key = a.currency.rawId.concat('-', a.earnAmount, '-', a.redeemAmount);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: key, className: 'allotment' },
        earn,
        redeem
      );
    }
  }, {
    key: 'renderCouponAllotment',
    value: function renderCouponAllotment(a) {
      var earn = void 0,
          redeem = void 0;

      var icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'icon-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_icons_TransactionCouponIcon__["a" /* default */], null)
      );

      if (a.earn) {
        earn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'earned' },
          icon,
          ' Coupon Earned - ',
          a.promotionName
        );
      }

      if (a.redeem) {
        redeem = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'redeemed' },
          icon,
          ' Coupon Redeemed - ',
          a.promotionName
        );
      }

      var key = a.couponId;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: key, className: 'allotment' },
        earn,
        redeem
      );
    }
  }, {
    key: 'renderTransactionItem',
    value: function renderTransactionItem(i) {
      var _this2 = this;

      var merchantName = i.node.merchant ? i.node.merchant.name : 'ZAP';
      var branchName = i.node.branch ? '(' + i.node.branch.name + ')' : '';
      var hasAmount = i.node.pointsAllotments.length > 0;
      var amountClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('amount', { 'currency-amount': hasAmount });
      var amount = hasAmount ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_components_helpers_utils__["c" /* Comatose */])(i.node.amount) : '--';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: i.node.id, className: 'item ' + i.node.status.toLowerCase() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'txnid' },
          i.node.rawId,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: i.node.status.toLowerCase() },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'bullet' }),
            i.node.status.toLowerCase()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'date' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_components_helpers_utils__["d" /* DateFormat */])(i.node.transactedAt),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_components_helpers_utils__["e" /* TimeFormat */])(i.node.transactedAt)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'merchant' },
          merchantName,
          ' ',
          branchName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: amountClass },
          amount
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'desc' },
          i.node.pointsAllotments.map(function (a) {
            return _this2.renderPointsAllotment(a, i.node.type, i.node.manualReason);
          }),
          i.node.couponAllotments.map(function (a) {
            return _this2.renderCouponAllotment(a);
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var seeMoreView = void 0;

      if (this.props.seeMore) {
        seeMoreView = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'see-more' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router__["g" /* Link */],
            { to: '/transactions' },
            'Click here to see more'
          )
        );
      }

      if (this.props.transactions.edges.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'transaction-list' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'txnid' },
              'Transaction ID'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'date' },
              'Date/Time'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'merchant' },
              'Merchant & Branch'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'amount' },
              'Amount'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'desc' },
              'Description'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'items' },
              this.props.transactions.edges.map(function (i) {
                return _this3.renderTransactionItem(i);
              })
            ),
            seeMoreView
          )
        );
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'no-transactions' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'No transactions.'
        )
      );
    }
  }]);

  return TransactionList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TransactionList.propTypes = {
  transactions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    edges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  seeMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
var _default = TransactionList;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TransactionList, 'TransactionList', '/home/circleci/project/js/components/widgets/TransactionList.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/widgets/TransactionList.js');
}();

;

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "js/components/images/invalid-496469a59d8a84221f82bed80526f6ec.svg";

/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PageLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParentRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_App__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_widgets_PageLoader__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_routes_MerchantRoute__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RegisterRoutes__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResetPasswordRoutes__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_config__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__ = __webpack_require__(116);














var Home = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1077));
});
var ConfirmEmailResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1074));
});
var ConfirmEmail = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1073));
});
var Corp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1076));
});
var Business = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1067));
});
var Contact = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1075));
});
var HowItWorks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1079));
});
var HowItWorksProcess = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1080));
});
var HowItWorksProcessInternational = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1066));
});
var HowItWorksFaq = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1078));
});
var Login = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1081));
});
var Merchants = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 320));
});
var Merchant = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1082));
});
var Privacy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1064));
});
var Terms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1065));
});
var Careers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1069));
});
var CareersHome = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1068));
});
var ManagementTraineeCebu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1071));
});
var ManagementTraineeManila = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1072));
});
var DeveloperManila = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1070));
});
var Dashboard = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 319));
});
var Transactions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1093));
});
var Wallet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 322));
});
var Profile = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 321));
});
var RedirectToStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["c" /* async */])(function () {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1083));
});

function returnProcess() {
  switch (document.domain) {
    case __WEBPACK_IMPORTED_MODULE_9_config__["b" /* USA_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_9_config__["c" /* SG_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_9_config__["d" /* MY_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_9_config__["e" /* VN_HOST */]:
      return HowItWorksProcessInternational;
    default:
      return HowItWorksProcess;
  }
}

function loginRoute() {
  switch (document.domain) {
    case __WEBPACK_IMPORTED_MODULE_9_config__["b" /* USA_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_9_config__["c" /* SG_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_9_config__["e" /* VN_HOST */]:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
    default:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
        path: "login",
        getComponent: Login,
        queries: __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__["a" /* default */].queries
      });
  }
}

function indexRoute() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* IndexRoute */], { getComponent: Home, queries: __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__["a" /* default */].queries });
}

function registerRoutes() {
  switch (document.domain) {
    case __WEBPACK_IMPORTED_MODULE_9_config__["b" /* USA_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_9_config__["c" /* SG_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_9_config__["e" /* VN_HOST */]:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
    default:
      return __WEBPACK_IMPORTED_MODULE_7__RegisterRoutes__["a" /* default */];
  }
}

function resetPasswordRoutes() {
  switch (document.domain) {
    case __WEBPACK_IMPORTED_MODULE_9_config__["b" /* USA_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_9_config__["c" /* SG_HOST */]:
    case __WEBPACK_IMPORTED_MODULE_9_config__["e" /* VN_HOST */]:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
    default:
      return __WEBPACK_IMPORTED_MODULE_8__ResetPasswordRoutes__["a" /* default */];
  }
}

var PageLoading = function PageLoading(Component, _ref) {
  var props = _ref.props;
  return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_widgets_PageLoader__["a" /* default */], null);
};

var ParentRoute = function ParentRoute(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { id: "container" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { id: "body" },
      props.children
    )
  );
};
ParentRoute.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired
};

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */],
  {
    path: "/",
    queries: __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__["a" /* default */].queries,
    component: __WEBPACK_IMPORTED_MODULE_3_components_App__["a" /* default */],
    onChange: __WEBPACK_IMPORTED_MODULE_10_components_helpers_routerUtils__["b" /* scrollToTop */],
    render: function render(args) {
      return PageLoading(__WEBPACK_IMPORTED_MODULE_3_components_App__["a" /* default */], args);
    }
  },
  loginRoute(),
  indexRoute(),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "home", getComponent: Home, queries: __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__["a" /* default */].queries }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
    path: "confirm-email-result/:status",
    getComponent: ConfirmEmailResult
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
    path: "confirm-email/:zapperId/confirm/:confirmationKey",
    getComponent: ConfirmEmail
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "corp/:corpName", getComponent: Corp }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "business", getComponent: Business }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "contact", getComponent: Contact }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["f" /* Redirect */], { from: "how-it-works", to: "/how-it-works/process" }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */],
    { path: "how-it-works", getComponent: HowItWorks },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "process", getComponent: returnProcess() }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "faq", getComponent: HowItWorksFaq })
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */],
    {
      path: "merchants",
      getComponent: Merchants,
      queries: __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__["a" /* default */].queries
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
      path: ":merchantName/:branchName/:id",
      getComponent: Merchant,
      queries: __WEBPACK_IMPORTED_MODULE_6_routes_MerchantRoute__["a" /* default */].queries
    })
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "privacy", getComponent: Privacy }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
    path: "terms",
    getComponent: Terms,
    render: function render(args) {
      return PageLoading(Terms, args);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */],
    { path: "careers", getComponent: Careers },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* IndexRoute */], { getComponent: CareersHome }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
      path: "management-trainee-cebu",
      getComponent: ManagementTraineeCebu
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
      path: "management-trainee-manila",
      getComponent: ManagementTraineeManila
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "developer-manila", getComponent: DeveloperManila })
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
    path: "dashboard",
    getComponent: Dashboard,
    queries: __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__["a" /* default */].queries
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
    path: "transactions",
    getComponent: Transactions,
    queries: __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__["a" /* default */].queries
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "wallet", getComponent: Wallet, queries: __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__["a" /* default */].queries }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], {
    path: "profile",
    getComponent: Profile,
    queries: __WEBPACK_IMPORTED_MODULE_5_routes_AppHomeRoute__["a" /* default */].queries
  }),
  resetPasswordRoutes(),
  registerRoutes(),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Route */], { path: "app", getComponent: RedirectToStore }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["f" /* Redirect */], { from: "!/*", to: "/*" }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["f" /* Redirect */], { from: "*", to: "/" })
);

/* harmony default export */ __webpack_exports__["c"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Home, "Home", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(ConfirmEmailResult, "ConfirmEmailResult", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(ConfirmEmail, "ConfirmEmail", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Corp, "Corp", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Business, "Business", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Contact, "Contact", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(HowItWorks, "HowItWorks", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(HowItWorksProcess, "HowItWorksProcess", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(HowItWorksProcessInternational, "HowItWorksProcessInternational", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(HowItWorksFaq, "HowItWorksFaq", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Login, "Login", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Merchants, "Merchants", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Merchant, "Merchant", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Privacy, "Privacy", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Terms, "Terms", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Careers, "Careers", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(CareersHome, "CareersHome", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(ManagementTraineeCebu, "ManagementTraineeCebu", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(ManagementTraineeManila, "ManagementTraineeManila", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(DeveloperManila, "DeveloperManila", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Dashboard, "Dashboard", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Transactions, "Transactions", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Wallet, "Wallet", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(Profile, "Profile", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(RedirectToStore, "RedirectToStore", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(returnProcess, "returnProcess", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(loginRoute, "loginRoute", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(indexRoute, "indexRoute", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(registerRoutes, "registerRoutes", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(resetPasswordRoutes, "resetPasswordRoutes", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(PageLoading, "PageLoading", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(ParentRoute, "ParentRoute", "/home/circleci/project/js/MainRoutes.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/MainRoutes.js");
}();

;

/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hot_loader__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_relay_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Root__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_helpers_routerUtils__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_theme__ = __webpack_require__(426);












__WEBPACK_IMPORTED_MODULE_8_components_helpers_routerUtils__["a" /* convertToNonHash */]();
__WEBPACK_IMPORTED_MODULE_2_react_ga___default.a.initialize(__WEBPACK_IMPORTED_MODULE_7_config__["a" /* GOOGLE_ANALYTICS_TRACKING_ID */]);
__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* browserHistory */].listen(function () {
  var p = window.location.pathname + window.location.search + window.location.hash;
  __WEBPACK_IMPORTED_MODULE_2_react_ga___default.a.pageview(p);
  __WEBPACK_IMPORTED_MODULE_2_react_ga___default.a.set({ page: p });
});
__WEBPACK_IMPORTED_MODULE_5_react_relay_classic___default.a.injectNetworkLayer(new __WEBPACK_IMPORTED_MODULE_5_react_relay_classic___default.a.DefaultNetworkLayer("/api" + "/graphql?silo_id=" + "ZAPMY", {
  mode: "cors",
  credentials: "include"
}));

var root = document.getElementById("root");

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_3_react_hot_loader__["AppContainer"],
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__material_ui_core__["a" /* MuiThemeProvider */],
    { theme: __WEBPACK_IMPORTED_MODULE_10__components_helpers_theme__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Root__["a" /* default */], null)
  )
), root);

if (false) {
  module.hot.accept("./Root", function () {
    var NewRoot = require("./Root").default;
    render(React.createElement(
      AppContainer,
      null,
      React.createElement(NewRoot, null)
    ), root);
  });
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(root, "root", "/home/circleci/project/js/app.js");
}();

;

/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_domainSettings__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_footer_less__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_footer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_footer_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { id: "footer" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "content" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "column" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */], { className: "logo", to: "/" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "country-selector" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "PH-flag flag", href: __WEBPACK_IMPORTED_MODULE_2_config__["m" /* PH_BUSINESS_HOST */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_domainSettings__["f" /* isPhDomain */])() ? "hidden" : "VN-flag flag",
                href: "//" + __WEBPACK_IMPORTED_MODULE_2_config__["e" /* VN_HOST */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "MY-flag flag", href: "//" + __WEBPACK_IMPORTED_MODULE_2_config__["d" /* MY_HOST */] })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "menu column" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "section" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                { className: "web-only", to: "/how-it-works" },
                "How It Works"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                { className: "web-only", to: "/merchants" },
                "Merchants"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                { className: "web-only", to: "/business" },
                "For Business"
              ),
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_domainSettings__["g" /* showFooterCareers */])() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                { to: "/careers" },
                "Careers"
              ) : null
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "section" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                { to: "/privacy" },
                "Privacy"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                { to: "/terms" },
                "Terms of Use"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                { className: "web-only", to: "/contact" },
                "Contact"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "social column" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
              className: "icon fb",
              href: "https://www.facebook.com/PoweredByZAP",
              target: "_blank"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
              className: "icon insta",
              href: "https://www.instagram.com/poweredbyzap",
              target: "_blank"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              "2012-",
              new Date().getFullYear(),
              " All rights reserved."
            ),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_domainSettings__["e" /* showAppSection */])() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
                className: "icon-app apple",
                href: "https://itunes.apple.com/ph/app/zap-philippines/id907381118",
                target: "_blank"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
                className: "icon-app android",
                href: "https://play.google.com/store/apps/details?id=ph.com.zap.android",
                target: "_blank"
              })
            ) : null
          )
        )
      );
    }
  }]);

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Footer;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Footer, "Footer", "/home/circleci/project/js/components/Footer.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/Footer.js");
}();

;

/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_icons_DashboardIcon__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_icons_TransactionsIcon__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_icons_WalletIcon__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_icons_MerchantsIcon__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_header_less__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_header_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_header_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_hamburger_less__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_hamburger_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_hamburger_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.state = {
      openDrawer: false,
      openDrowdown: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "toggleDrawer",
    value: function toggleDrawer() {
      this.setState({ openDrawer: !this.state.openDrawer });
    }
  }, {
    key: "unToggleDrawer",
    value: function unToggleDrawer() {
      this.setState({ openDrawer: false });
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      this.setState({ openDropdown: !this.state.openDropdown });
    }
  }, {
    key: "unToggleDropdown",
    value: function unToggleDropdown() {
      this.setState({ openDropdown: false });
    }
  }, {
    key: "unToggleAll",
    value: function unToggleAll() {
      this.unToggleDrawer();
      this.unToggleDropdown();
    }
  }, {
    key: "logout",
    value: function logout() {
      this.unToggleAll();
      if (this.props.logout) {
        this.props.logout();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isLoggedIn = this.props.zapperId !== null;
      var firstName = this.props.firstName || null;

      var hasNoLoginRegister = document.domain === __WEBPACK_IMPORTED_MODULE_8_config__["b" /* USA_HOST */] || document.domain === __WEBPACK_IMPORTED_MODULE_8_config__["c" /* SG_HOST */] || document.domain === __WEBPACK_IMPORTED_MODULE_8_config__["e" /* VN_HOST */];

      var hamburgerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("hamburger", {
        active: this.state.openDrawer
      });

      var menuClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("menu", {
        in: this.state.openDrawer
      });

      var menuContainerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("menu-container", {
        in: this.state.openDrawer
      });

      var homeClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("mobile-only", "home", {
        active: typeof this.props.routes[1].path === "undefined",
        hide: isLoggedIn
      });

      var howitworksClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("how-it-works", {
        hide: this.props.routes[1].path === "business",
        active: this.props.routes[1].path === "how-it-works"
      });

      var contactClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("contact", {
        hide: this.props.routes[1].path === "business",
        active: this.props.routes[1].path === "contact"
      });

      var merchantsClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("merchants", {
        hide: this.props.routes[1].path === "business" || isLoggedIn,
        active: this.props.routes[1].path === "merchants"
      });

      var registerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("register", {
        hide: this.props.routes[1].path === "business" || isLoggedIn || hasNoLoginRegister,
        active: this.props.routes[1].path === "register",
        register: true
      });

      var loginClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("login", {
        hide: this.props.routes[1].path === "business" || isLoggedIn || hasNoLoginRegister,
        active: this.props.routes[1].path === "login"
      });

      var dashboardClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("dashboard", {
        hide: this.props.routes[1].path === "business" || !isLoggedIn
      });

      var myAccountClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("my-account", {
        hide: this.props.routes[1].path === "business" || !isLoggedIn
      });

      var logoutClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("logout", {
        hide: this.props.routes[1].path === "business" || !isLoggedIn
      });

      var businessClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("business", {
        hide: this.props.routes[1].path === "business" || isLoggedIn,
        business: true
      });

      var membersClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        hide: this.props.routes[1].path !== "business",
        business: true
      });

      var subContentClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("subcontent", {
        hide: this.props.routes[1].path === "business" || !isLoggedIn
      });

      var subDashboardClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        active: this.props.routes[1].path === "dashboard"
      });

      var subTransactionsClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        active: this.props.routes[1].path === "transactions"
      });

      var subWalletClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        active: this.props.routes[1].path === "wallet"
      });

      var subMerchantsClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        active: this.props.routes[1].path === "merchants"
      });

      var dropdownMenuClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("drop-down-menu", {
        in: this.state.openDropdown
      });

      var dropdownButtonClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("drop-down-button", {
        hide: !isLoggedIn
      });

      var headerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        in: this.state.openDrawer,
        transparent: this.props.isTransparent
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { id: "header", className: headerClass },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "content" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */], { className: "logo", to: "/" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: menuContainerClass },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { id: "menu", className: menuClass },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  onClick: function onClick() {
                    return _this2.unToggleAll();
                  },
                  className: homeClass,
                  to: "/"
                },
                "Home"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  onClick: function onClick() {
                    return _this2.unToggleAll();
                  },
                  className: howitworksClass,
                  to: "/how-it-works"
                },
                "How It Works"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  onClick: function onClick() {
                    return _this2.unToggleAll();
                  },
                  className: contactClass,
                  to: "/contact"
                },
                "Contact"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  onClick: function onClick() {
                    return _this2.unToggleDrawer();
                  },
                  className: merchantsClass,
                  to: "/merchants"
                },
                "Merchants"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  onClick: function onClick() {
                    return _this2.unToggleDrawer();
                  },
                  className: registerClass,
                  to: "/register"
                },
                "Free Sign Up"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  onClick: function onClick() {
                    return _this2.unToggleDrawer();
                  },
                  className: loginClass,
                  to: "/login"
                },
                "Login"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  onClick: function onClick() {
                    return _this2.unToggleDrawer();
                  },
                  className: dashboardClass,
                  to: "/dashboard"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "border" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: this.props.image }),
                firstName
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
                className: dropdownButtonClass,
                tabIndex: "2",
                onClick: function onClick() {
                  return _this2.toggleDropdown();
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: dropdownMenuClass, tabIndex: "1" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "arrow" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "container" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                    {
                      className: myAccountClass,
                      to: "/profile",
                      onClick: function onClick() {
                        return _this2.unToggleAll();
                      }
                    },
                    "My Account"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "a",
                    {
                      onClick: function onClick() {
                        _this2.logout();
                        _this2.unToggleAll();
                      },
                      className: logoutClass
                    },
                    "Logout"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  onClick: function onClick() {
                    return _this2.unToggleDrawer();
                  },
                  className: businessClass,
                  to: document.domain === __WEBPACK_IMPORTED_MODULE_8_config__["h" /* PH_HOST */] ? __WEBPACK_IMPORTED_MODULE_8_config__["m" /* PH_BUSINESS_HOST */] : "/business",
                  target: document.domain === __WEBPACK_IMPORTED_MODULE_8_config__["h" /* PH_HOST */] ? "_blank" : ""
                },
                "For Business"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  onClick: function onClick() {
                    return _this2.unToggleDrawer();
                  },
                  className: membersClass,
                  to: "/"
                },
                "For Members"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              className: hamburgerClass,
              onBlur: function onBlur() {
                return _this2.unToggleDrawer();
              },
              onClick: function onClick() {
                return _this2.toggleDrawer();
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "="
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: subContentClass },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "submenu" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  className: subDashboardClass,
                  to: "/dashboard",
                  onClick: function onClick() {
                    return _this2.unToggleAll();
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "icon" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_icons_DashboardIcon__["a" /* default */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "Dashboard"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  className: subTransactionsClass,
                  to: "/transactions",
                  onClick: function onClick() {
                    return _this2.unToggleAll();
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "icon" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icons_TransactionsIcon__["a" /* default */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "Transactions"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  className: subWalletClass,
                  to: "/wallet",
                  onClick: function onClick() {
                    return _this2.unToggleAll();
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "icon" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_icons_WalletIcon__["a" /* default */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "Wallet"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* Link */],
                {
                  className: subMerchantsClass,
                  to: "/merchants",
                  onClick: function onClick() {
                    return _this2.unToggleAll();
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "icon" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_icons_MerchantsIcon__["a" /* default */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "Merchants"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Header.propTypes = {
  routes: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })).isRequired,
  logout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  zapperId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  firstName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  isTransparent: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var _default = Header;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Header, "Header", "/home/circleci/project/js/components/Header.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/Header.js");
}();

;

/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(71);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var useStyle = function useStyle(theme) {
  return {
    container: {
      position: "relative",
      zIndex: "1",
      display: "flex",
      justifyContent: "center",
      width: "100%",
      height: "242px",
      background: "#2B2B2B",
      gap: "40px",
      padding: "56px 80px",

      "@media (max-width:1439px)": {
        padding: "56px"
      },

      "@media (max-width:1251px)": {
        padding: "40px",
        height: "auto",
        flexDirection: "column",
        alignItems: "flex-start"
      },

      "@media (max-width:990px)": {
        padding: "40px 24px"
      }
    },

    bottomLogo: {
      width: "200px",
      height: "72px",
      cursor: "pointer"
    },

    linkContainer: {
      display: "flex",
      gap: "80px",
      width: "100%",
      maxWidth: "472px",

      "@media (max-width:478px)": {
        gap: "40px",
        flexDirection: "column"
      }
    },

    linkColumn: {
      display: "flex",
      flexDirection: "column",
      color: "#FFFFFF",
      gap: "24px",

      "& span": {
        fontFamily: "manrope-regular-webfont",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "18px",
        letterSpacing: "1.2px"
      },

      "& a": {
        fontFamily: "manrope-regular-webfont",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: "24px",
        cursor: "pointer"
      },

      "& div": {
        display: "flex",
        flexDirection: "column",
        gap: "8px"
      }
    },

    appContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",

      "& img": {
        width: "157px",
        height: "48px",
        cursor: "pointer"
      },

      "@media (max-width:1251px)": {
        flexDirection: "row"
      },

      "@media (max-width:478px)": {
        flexDirection: "column"
      }
    },

    endContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      width: "100%",
      maxWidth: "190px",
      alignItems: "flex-end",

      "@media (max-width:1251px)": {
        alignItems: "flex-start"
      },

      "& span": {
        textAlign: "right",
        color: "#FFFFFF",
        fontFamily: "manrope-regular-webfont",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: "18px"
      }
    },

    flags: {
      display: "inline-flex",
      gap: "16px",

      "& img": {
        height: "40px",
        width: "40px",
        borderRadius: "100%",
        cursor: "pointer"
      }
    },

    socials: {
      display: "inline-flex",
      gap: "8px",
      "& img": {
        cursor: "pointer",
        width: "20px",
        height: "20px"
      }
    }
  };
};

var PhFooter = function (_Component) {
  _inherits(PhFooter, _Component);

  function PhFooter() {
    _classCallCheck(this, PhFooter);

    return _possibleConstructorReturn(this, (PhFooter.__proto__ || Object.getPrototypeOf(PhFooter)).apply(this, arguments));
  }

  _createClass(PhFooter, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: classes.container },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes.bottomLogo },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
              { to: "/" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(827) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes.linkContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: classes.linkColumn },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                "PRODUCTS"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
                  { to: "/" },
                  "ZAP Loyalty"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
                  { to: __WEBPACK_IMPORTED_MODULE_3_config__["n" /* E_STORE_LINK */], target: "_blank" },
                  "ZAP E-Store"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
                  { to: __WEBPACK_IMPORTED_MODULE_3_config__["o" /* ZAP_DEALS_LINK */], target: "_blank" },
                  "ZAP Deals"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: classes.linkColumn },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                "RESOURCES"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
                  { to: "https://blog.zapestore.com", target: "_blank" },
                  "Blog"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
                  { to: "/contact" },
                  "Contact Us"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: classes.linkColumn },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                "LEGAL"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
                  { to: "terms" },
                  "Terms"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
                  { to: "/privacy" },
                  "Privacy"
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes.appContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
              { to: __WEBPACK_IMPORTED_MODULE_3_config__["g" /* APP_STORE_LINK */], target: "_blank" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(821) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
              { to: __WEBPACK_IMPORTED_MODULE_3_config__["f" /* PLAY_STORE_LINK */], target: "_blank" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(826) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes.endContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: classes.flags },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { href: "//" + __WEBPACK_IMPORTED_MODULE_3_config__["h" /* PH_HOST */] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(825) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { href: "//" + __WEBPACK_IMPORTED_MODULE_3_config__["d" /* MY_HOST */] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(824) })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: classes.socials },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
                {
                  to: "https://www.facebook.com/PoweredByZAP",
                  target: "_blank"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(822) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* Link */],
                { to: "https://instagram.com/poweredbyzap", target: "_blank" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(823) })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "2012-",
              new Date().getFullYear(),
              " All rights reserved."
            )
          )
        )
      );
    }
  }]);

  return PhFooter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["b" /* withStyles */])(useStyle())(PhFooter);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(useStyle, "useStyle", "/home/circleci/project/js/components/PhFooter.js");

  __REACT_HOT_LOADER__.register(PhFooter, "PhFooter", "/home/circleci/project/js/components/PhFooter.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/PhFooter.js");
}();

;

/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return breakpoints; });
var breakpoints = {
  values: {
    mobileSmall: 0, // mobileSmall
    mobilePortrait: 479, // mobilePortrait
    mobileLandscape: 767, // mobileLandscape
    tablet: 991, // tablet
    desktopSmall: 1252, // desktopSmall
    desktopLarge: 1440 // desktopLarge
  }
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(breakpoints, "breakpoints", "/home/circleci/project/js/components/helpers/breakpoints.js");
}();

;

/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DashboardIcon = function (_React$Component) {
  _inherits(DashboardIcon, _React$Component);

  function DashboardIcon() {
    _classCallCheck(this, DashboardIcon);

    return _possibleConstructorReturn(this, (DashboardIcon.__proto__ || Object.getPrototypeOf(DashboardIcon)).apply(this, arguments));
  }

  _createClass(DashboardIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { height: "100%", viewBox: "0 0 18.714 16.422" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          fill: "#BD311F",
          d: "M18.617,9.131L9.65,0.058c-0.076-0.077-0.213-0.077-0.289,0L0.364,9.162C0.306,9.22,0.035,9.307,0.067,9.383 C0.098,9.459,0,9.53,0,9.53V9.422h3v6.797v0.203H2.998H7V9.915V9.422h5v7h3.402h0.203c0.112,0,0.394-0.091,0.394-0.203V9.422h2.502 c0.003,0,0.005,0,0.008,0c0.112,0,0.203-0.048,0.203-0.16C18.714,9.188,18.675,9.167,18.617,9.131z"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { id: "BS8q3m.tif" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image", {
            overflow: "visible",
            width: "17",
            height: "17",
            id: "Layer_0_1_",
            transform: "matrix(1 0 0 1 104 -0.2892)"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { x: "71", y: "2.422", fill: "#BD311F", width: "17", height: "14" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          fill: "#BD311F",
          d: "M75,4.672c0,0.414-0.336,0.75-0.75,0.75h-0.5c-0.414,0-0.75-0.336-0.75-0.75v-3.5 c0-0.414,0.336-0.75,0.75-0.75h0.5c0.414,0,0.75,0.336,0.75,0.75V4.672z"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          fill: "#BD311F",
          d: "M80,3.672c0,0.414-0.336,0.75-0.75,0.75h-0.5c-0.414,0-0.75-0.336-0.75-0.75v-3.5 c0-0.414,0.336-0.75,0.75-0.75h0.5c0.414,0,0.75,0.336,0.75,0.75V3.672z"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null)
      );
    }
  }]);

  return DashboardIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = DashboardIcon;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DashboardIcon, "DashboardIcon", "/home/circleci/project/js/components/icons/DashboardIcon.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/icons/DashboardIcon.js");
}();

;

/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DashboardIcon = function (_React$Component) {
  _inherits(DashboardIcon, _React$Component);

  function DashboardIcon() {
    _classCallCheck(this, DashboardIcon);

    return _possibleConstructorReturn(this, (DashboardIcon.__proto__ || Object.getPrototypeOf(DashboardIcon)).apply(this, arguments));
  }

  _createClass(DashboardIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        {
          height: "100%",
          viewBox: "0 0 20.002 17",
          enableBackground: "new 0 0 20.002 17"
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { x: "2.995", fill: "#BD311F", width: "14", height: "2" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#BD311F",
            d: "M19.877,6.475C19.877,6.02,20.124,5,19.925,5h0.047l-2.063-2H2.228L0.062,5h0.034 c-0.199,0-0.026,1.02-0.026,1.475c0,1.109,0.925,2.284,1.925,2.697v7.003C1.995,16.631,1.772,17,2.228,17h15.681 c0.456,0,0.086-0.369,0.086-0.825V9.109C18.995,8.67,19.877,7.537,19.877,6.475z M3.995,15V9.32c1-0.2,1.141-0.835,1.458-1.676 c0.384,1.019,1.125,1.748,2.279,1.748c1.154,0,2.013-0.729,2.397-1.748c0.384,1.019,1.302,1.748,2.455,1.748 c1.154,0,1.556-0.729,1.94-1.748c0.331,0.877,0.471,1.536,1.471,1.704V15H3.995z"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", {
          x: "3.995",
          y: "6",
          className: "fill-none stroke",
          fill: "none",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: "10",
          width: "12",
          height: "9"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null)
      );
    }
  }]);

  return DashboardIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = DashboardIcon;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DashboardIcon, "DashboardIcon", "/home/circleci/project/js/components/icons/MerchantsIcon.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/icons/MerchantsIcon.js");
}();

;

/***/ }),

/***/ 684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var TransactionCouponIcon = function (_React$Component) {
  _inherits(TransactionCouponIcon, _React$Component);

  function TransactionCouponIcon() {
    _classCallCheck(this, TransactionCouponIcon);

    return _possibleConstructorReturn(this, (TransactionCouponIcon.__proto__ || Object.getPrototypeOf(TransactionCouponIcon)).apply(this, arguments));
  }

  _createClass(TransactionCouponIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { height: "100%", viewBox: "0 0 30.227 19.263" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#6FCBE9", d: "M30.227,5.82V0h-5.67v0.995h-1.327V0H0v5.82c2.105,0,3.811,1.706,3.811,3.811 c0,2.105-1.706,3.811-3.811,3.811v5.82h30.227v-5.82c-2.105,0-3.811-1.706-3.811-3.811C26.415,7.526,28.122,5.82,30.227,5.82z M17.021,13.833H9.945c-2.317,0-4.202-1.885-4.202-4.202s1.885-4.202,4.202-4.202h7.077c2.317,0,4.202,1.885,4.202,4.202 S19.338,13.833,17.021,13.833z M24.556,19.262h-1.327v-0.995h1.327V19.262z M24.556,16.348h-1.327v-1.919h1.327V16.348z M24.556,12.51h-1.327v-1.919h1.327V12.51z M24.556,8.672h-1.327V6.752h1.327V8.672z M24.556,4.833h-1.327V2.914h1.327V4.833z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#6FCBE9", d: "M17.021,6.756H9.945c-1.585,0-2.875,1.29-2.875,2.875c0,1.585,1.29,2.875,2.875,2.875h7.077 c1.585,0,2.875-1.29,2.875-2.875C19.897,8.046,18.607,6.756,17.021,6.756z" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null)
      );
    }
  }]);

  return TransactionCouponIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TransactionCouponIcon;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TransactionCouponIcon, "TransactionCouponIcon", "/home/circleci/project/js/components/icons/TransactionCouponIcon.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/icons/TransactionCouponIcon.js");
}();

;

/***/ }),

/***/ 685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var TransactionZapCashIcon = function (_React$Component) {
  _inherits(TransactionZapCashIcon, _React$Component);

  function TransactionZapCashIcon() {
    _classCallCheck(this, TransactionZapCashIcon);

    return _possibleConstructorReturn(this, (TransactionZapCashIcon.__proto__ || Object.getPrototypeOf(TransactionZapCashIcon)).apply(this, arguments));
  }

  _createClass(TransactionZapCashIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { height: "100%", viewBox: "0 0 32.047 19.327" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#6FCBE9",
            d: "M17.188,9.698V8.839c0-0.227-0.075-0.478-0.224-0.746c-0.156-0.282-0.367-0.538-0.627-0.762 c-0.261-0.225-0.573-0.413-0.927-0.557c-0.346-0.141-0.702-0.213-1.056-0.214c-0.717,0.028-1.305,0.281-1.798,0.774 c-0.495,0.495-0.763,1.09-0.819,1.818c0.001,0.136,0.011,0.271,0.03,0.404c0.001,0,0.001,0,0.001,0 c0.035,0.236,0.098,0.466,0.191,0.689c0.147,0.354,0.356,0.673,0.621,0.95c0.264,0.275,0.571,0.492,0.912,0.645 c0.338,0.151,0.699,0.228,1.071,0.228c0.68,0,1.764-0.37,2.626-1.404c0,0-0.001-0.677-0.002-0.953 C17.188,9.705,17.188,9.698,17.188,9.698z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#6FCBE9",
            d: "M25.304,7.901c-0.233-0.388-0.544-0.699-0.923-0.922c-0.379-0.224-0.81-0.351-1.282-0.378 c-0.354,0.001-0.705,0.074-1.044,0.216c-0.351,0.147-0.668,0.34-0.943,0.574c-0.271,0.231-0.486,0.487-0.64,0.761 c-0.146,0.26-0.22,0.507-0.22,0.733v0.422l0.002,1.538c0.656,0.673,1.701,1.325,2.612,1.28c0.573-0.027,1.027-0.155,1.43-0.405 c0.438-0.271,0.789-0.635,1.043-1.082c0.251-0.441,0.379-0.921,0.381-1.426c-0.023-0.267-0.133-0.652-0.227-0.918 C25.438,8.159,25.379,8.026,25.304,7.901z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#6FCBE9",
            d: "M28.247,0H3.8C1.701,0,0,1.701,0,3.8v11.726c0,2.099,1.701,3.8,3.8,3.8h24.446c2.099,0,3.8-1.702,3.8-3.8 V3.8C32.047,1.701,30.346,0,28.247,0z M11.302,13.029H4.453l3.016-4.142c0,0-0.001,0-0.002,0l1.525-2.095H4.741V5.586h6.65 L8.78,9.161l0.001,0l-1.964,2.691h3.772c0.275,0.332,0.497,0.555,0.91,0.891c0.171,0.14,0.417,0.286,0.417,0.286H11.302z M18.382,12.915H17.19v-0.589c-0.355,0.259-0.726,0.478-1.042,0.611c-0.517,0.216-1.049,0.326-1.584,0.326 c-0.721,0-1.399-0.191-2.015-0.568c-0.611-0.374-1.103-0.886-1.462-1.52c-0.304-0.539-0.48-1.125-0.526-1.744 c-0.001,0-0.001,0-0.002,0c-0.008-0.11-0.014-0.22-0.014-0.332l0.001-0.021c0.047-0.67,0.242-1.291,0.577-1.848 c0.337-0.559,0.79-1.011,1.346-1.342c0.558-0.332,1.177-0.511,1.84-0.532h0.01c0.685,0,1.348,0.165,1.971,0.491 c0.623,0.326,1.129,0.76,1.506,1.29c0.387,0.544,0.583,1.117,0.583,1.704V9.64l0.002,0V12.915z M26.368,11.21 c-0.36,0.637-0.852,1.15-1.461,1.524c-0.613,0.377-1.29,0.568-2.012,0.568c-0.354,0-0.706-0.048-1.045-0.14 c-0.338-0.093-0.687-0.241-1.036-0.442c-0.188-0.108-0.378-0.232-0.559-0.364v3.816h-1.192V9.592c0,0-0.001,0-0.002,0V8.88 c0-0.451,0.113-0.893,0.338-1.314c0.219-0.411,0.524-0.783,0.908-1.109c0.381-0.323,0.821-0.581,1.308-0.767 c0.489-0.187,1.002-0.282,1.523-0.282h0.01c0.492,0.016,0.969,0.121,1.417,0.312c0.448,0.191,0.844,0.455,1.178,0.785 c0.325,0.323,0.591,0.711,0.795,1.151c0.005-0.003,0.01-0.006,0.015-0.008c0.023,0.06,0.048,0.135,0.072,0.206 c0.006,0.014,0.012,0.028,0.018,0.042c-0.001,0-0.002,0.001-0.003,0.001c0.127,0.383,0.252,0.873,0.274,1.214l0.001,0.02 C26.912,9.873,26.729,10.573,26.368,11.21z M27.957,8.794c-0.005,0.077-0.068,0.136-0.143,0.136H27.81h-0.075h-0.004 c-0.04,0-0.078-0.017-0.105-0.046c-0.027-0.03-0.041-0.069-0.038-0.109c0.006-0.101,0.01-0.185,0.01-0.266 c0-0.352-0.047-0.692-0.132-1.018c-0.444-1.687-1.959-2.935-3.759-2.935c-0.079,0-0.143-0.065-0.143-0.145v-0.08 c0-0.081,0.064-0.146,0.143-0.146c2.128,0,3.891,1.592,4.206,3.663c0.001,0.01,0.003,0.019,0.004,0.028 c0.03,0.207,0.051,0.417,0.051,0.632C27.967,8.595,27.964,8.686,27.957,8.794z M28.977,8.794c-0.005,0.103-0.089,0.184-0.191,0.184 h-0.004h-0.075h-0.004c-0.052,0-0.102-0.022-0.139-0.06c-0.036-0.039-0.055-0.091-0.052-0.143c0.005-0.091,0.007-0.18,0.007-0.265 c0-0.298-0.027-0.59-0.077-0.873l0-0.001c-0.023-0.131-0.053-0.258-0.086-0.385c-0.004-0.017-0.008-0.034-0.013-0.051 c-0.033-0.121-0.072-0.24-0.114-0.357c-0.673-1.876-2.444-3.221-4.523-3.221c-0.106,0-0.191-0.087-0.191-0.194V3.348 c0-0.107,0.085-0.194,0.191-0.194c2.91,0,5.278,2.402,5.278,5.355C28.984,8.6,28.982,8.696,28.977,8.794z"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null)
      );
    }
  }]);

  return TransactionZapCashIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TransactionZapCashIcon;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TransactionZapCashIcon, "TransactionZapCashIcon", "/home/circleci/project/js/components/icons/TransactionZapCardIcon.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/icons/TransactionZapCardIcon.js");
}();

;

/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var TransactionZapCashIcon = function (_React$Component) {
  _inherits(TransactionZapCashIcon, _React$Component);

  function TransactionZapCashIcon() {
    _classCallCheck(this, TransactionZapCashIcon);

    return _possibleConstructorReturn(this, (TransactionZapCashIcon.__proto__ || Object.getPrototypeOf(TransactionZapCashIcon)).apply(this, arguments));
  }

  _createClass(TransactionZapCashIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { height: "100%", viewBox: "0 0 25.929 25.929" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          fill: "#6FCBE9",
          d: "M12.965,0C5.804,0,0,5.804,0,12.965c0,7.16,5.805,12.965,12.965,12.965c7.16,0,12.965-5.805,12.965-12.965 C25.929,5.804,20.125,0,12.965,0z M18.796,18.808h-2.732v2.175c0,0.08-0.065,0.145-0.145,0.145h-1.904 c-0.08,0-0.145-0.065-0.145-0.145v-2.175h-1.772v2.175c0,0.08-0.065,0.145-0.145,0.145h-1.904c-0.08,0-0.145-0.065-0.145-0.145 v-2.175h-2.77c-0.046,0-0.089-0.039-0.109-0.08c-0.021-0.041-0.017-0.104,0.01-0.141l6.803-9.399H7.625 c-0.068,0-0.126-0.044-0.126-0.112V7.153c0-0.068,0.059-0.116,0.126-0.116h2.279V4.946c0-0.08,0.065-0.145,0.145-0.145h1.904 c0.08,0,0.145,0.065,0.145,0.145v2.091h1.772V4.946c0-0.08,0.065-0.145,0.145-0.145h1.904c0.08,0,0.145,0.065,0.145,0.145v2.091 h2.103c0.046,0,0.089,0.021,0.109,0.063c0.021,0.041,0.017,0.086-0.01,0.124l-6.839,9.392h5.508c0.042,0,0.082,0.024,0.104,0.061 c0.509,0.818,1.023,1.359,1.824,1.892c0.045,0.03,0.065,0.092,0.049,0.144C18.898,18.763,18.85,18.808,18.796,18.808z"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null)
      );
    }
  }]);

  return TransactionZapCashIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TransactionZapCashIcon;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TransactionZapCashIcon, "TransactionZapCashIcon", "/home/circleci/project/js/components/icons/TransactionZapCashIcon.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/icons/TransactionZapCashIcon.js");
}();

;

/***/ }),

/***/ 687:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DashboardIcon = function (_React$Component) {
  _inherits(DashboardIcon, _React$Component);

  function DashboardIcon() {
    _classCallCheck(this, DashboardIcon);

    return _possibleConstructorReturn(this, (DashboardIcon.__proto__ || Object.getPrototypeOf(DashboardIcon)).apply(this, arguments));
  }

  _createClass(DashboardIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { height: "100%", viewBox: "0 0 18 17" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            className: "fill-none",
            fill: "none",
            d: "M14.519,13H3.481C3.215,13,3,13.215,3,13.481v0.038C3,13.785,3.215,14,3.481,14h11.038 C14.785,14,15,13.785,15,13.519v-0.038C15,13.215,14.785,13,14.519,13z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            className: "fill-none",
            fill: "none",
            d: "M14.519,10H3.481C3.215,10,3,10.215,3,10.481v0.038C3,10.785,3.215,11,3.481,11h11.038 C14.785,11,15,10.785,15,10.519v-0.038C15,10.215,14.785,10,14.519,10z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            className: "fill-none",
            fill: "none",
            d: "M14.519,7H3.481C3.215,7,3,7.215,3,7.481v0.038C3,7.785,3.215,8,3.481,8h11.038C14.785,8,15,7.785,15,7.519 V7.481C15,7.215,14.785,7,14.519,7z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#BD311F",
            d: "M4.178,0H3.822C3.797,0,3.775,0.012,3.75,0.015C3.332,0.053,3,0.395,3,0.823V2v1.177 C3,3.631,3.369,4,3.822,4h0.355C4.631,4,5,3.631,5,3.177V2V1.323v-0.5C5,0.369,4.631,0,4.178,0z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#BD311F",
            d: "M9.178,0H8.822C8.797,0,8.775,0.012,8.75,0.015C8.332,0.053,8,0.395,8,0.823V2v1.177 C8,3.631,8.369,4,8.822,4h0.355C9.631,4,10,3.631,10,3.177V2V1.323v-0.5C10,0.369,9.631,0,9.178,0z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#BD311F",
            d: "M14.178,0h-0.355c-0.026,0-0.047,0.012-0.072,0.015C13.332,0.053,13,0.395,13,0.823V2v1.177 C13,3.631,13.369,4,13.822,4h0.355C14.631,4,15,3.631,15,3.177V2V1.323v-0.5C15,0.369,14.631,0,14.178,0z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#BD311F",
            d: "M16,2v1.177C16,4.182,15.183,5,14.178,5h-0.355c-0.033,0-0.064-0.008-0.097-0.01 C12.766,4.939,12,4.149,12,3.177V2h-1v1.177C11,4.182,10.183,5,9.178,5H8.822C8.789,5,8.758,4.992,8.726,4.99 C7.766,4.939,7,4.149,7,3.177V2H6v1.177C6,4.182,5.183,5,4.178,5H3.822C3.789,5,3.758,4.992,3.726,4.99 C2.766,4.939,2,4.149,2,3.177V2H0v15h18V2H16z M15,13.519C15,13.785,14.785,14,14.519,14H3.481C3.215,14,3,13.785,3,13.519v-0.038 C3,13.215,3.215,13,3.481,13h11.038C14.785,13,15,13.215,15,13.481V13.519z M15,10.519C15,10.785,14.785,11,14.519,11H3.481 C3.215,11,3,10.785,3,10.519v-0.038C3,10.215,3.215,10,3.481,10h11.038C14.785,10,15,10.215,15,10.481V10.519z M15,7.519 C15,7.785,14.785,8,14.519,8H3.481C3.215,8,3,7.785,3,7.519V7.481C3,7.215,3.215,7,3.481,7h11.038C14.785,7,15,7.215,15,7.481 V7.519z"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null)
      );
    }
  }]);

  return DashboardIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = DashboardIcon;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DashboardIcon, "DashboardIcon", "/home/circleci/project/js/components/icons/TransactionsIcon.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/icons/TransactionsIcon.js");
}();

;

/***/ }),

/***/ 688:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DashboardIcon = function (_React$Component) {
  _inherits(DashboardIcon, _React$Component);

  function DashboardIcon() {
    _classCallCheck(this, DashboardIcon);

    return _possibleConstructorReturn(this, (DashboardIcon.__proto__ || Object.getPrototypeOf(DashboardIcon)).apply(this, arguments));
  }

  _createClass(DashboardIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { height: "100%", viewBox: "-0.037 -0.58 19.147 17.496" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#BD311F", d: "M16.466,11.965c-0.864,0-1.648-0.701-1.648-1.565v-0.006c0-0.864,0.783-1.565,1.648-1.565h2.644V5.362 c0-0.912-0.656-1.651-1.568-1.651H1.696c-0.912,0-1.733,0.739-1.733,1.651v9.904c0,0.912,0.822,1.651,1.733,1.651h15.846 c0.912,0,1.568-0.739,1.568-1.651v-3.301H16.466z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { fill: "#BD311F", cx: "16.993", cy: "10.397", r: "0.64" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#BD311F", d: "M11.124,2.371L9.981-0.422C9.955-0.485,9.905-0.535,9.842-0.561S9.708-0.586,9.646-0.559L3.17,2.234 C3.06,2.282,2.998,2.401,3.022,2.519C3.046,2.637,3.15,2.721,3.271,2.721h7.618c0.085,0,0.164-0.042,0.211-0.112 C11.147,2.539,11.156,2.45,11.124,2.371z" })
        )
      );
    }
  }]);

  return DashboardIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = DashboardIcon;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DashboardIcon, "DashboardIcon", "/home/circleci/project/js/components/icons/WalletIcon.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/home/circleci/project/js/components/icons/WalletIcon.js");
}();

;

/***/ }),

/***/ 689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_styles_date_picker_less__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_styles_date_picker_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_styles_date_picker_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DatePicker = function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      month: null,
      date: null,
      year: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DatePicker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.value) {
        this.setState({
          month: this.props.value.month(),
          date: this.props.value.date(),
          year: this.props.value.year()
        });
      }
    }
  }, {
    key: 'getDates',
    value: function getDates() {
      var dates = [];
      var i = 1;

      for (i = 1; i <= 31; i++) {
        dates.push(i);
      }

      return dates.map(function (v) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { key: v, value: v },
          v
        );
      });
    }
  }, {
    key: 'getYears',
    value: function getYears() {
      var years = [];
      var i = 0;
      var start = new Date().getFullYear();

      for (i = 0; i <= 130; i++) {
        years.push(start - i);
      }

      return years.map(function (v) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { key: v, value: v },
          v
        );
      });
    }
  }, {
    key: 'emitChange',
    value: function emitChange() {
      var date = null;
      if (Number.isInteger(this.state.month) && this.state.date && this.state.year) {
        date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.state.year + '-' + (this.state.month + 1) + '-' + this.state.date, 'YYYY-MM-DD');
      }

      this.props.onChange(date);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'date-picker' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'select',
          {
            className: 'select-month',
            onChange: function onChange(b) {
              _this2.state.month = parseInt(b.target.value, 10);
              _this2.emitChange();
            },
            value: Number.isInteger(this.state.month) ? this.state.month : 'Month'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { 'default': true, disabled: true },
            'Month'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 0 },
            'Jan'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 1 },
            'Feb'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 2 },
            'Mar'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 3 },
            'Apr'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 4 },
            'May'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 5 },
            'Jun'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 6 },
            'Jul'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 7 },
            'Aug'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 8 },
            'Sep'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 9 },
            'Oct'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 10 },
            'Nov'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: 11 },
            'Dec'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'select',
          {
            className: 'select-date',
            value: this.state.date ? this.state.date : 'Day',
            onChange: function onChange(b) {
              _this2.state.date = parseInt(b.target.value, 10);
              _this2.emitChange();
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { 'default': true, disabled: true },
            'Day'
          ),
          this.getDates()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'select',
          {
            className: 'select-year',
            value: this.state.year ? this.state.year : 'Year',
            onChange: function onChange(b) {
              _this2.state.year = parseInt(b.target.value, 10);
              _this2.emitChange();
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { 'default': true, disabled: true },
            'Year'
          ),
          this.getYears()
        )
      );
    }
  }]);

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DatePicker.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var _default = DatePicker;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DatePicker, 'DatePicker', '/home/circleci/project/js/components/widgets/DatePicker.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/widgets/DatePicker.js');
}();

;

/***/ }),

/***/ 690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_widgets_ZElements__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_dialog_less__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_dialog_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_dialog_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_email_dialog_less__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_email_dialog_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_email_dialog_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_info_dialog_less__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_info_dialog_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_info_dialog_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_error_dialog_less__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_error_dialog_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_error_dialog_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Dialog = function (_React$Component) {
  _inherits(Dialog, _React$Component);

  function Dialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      submitted: false
    }, _this.onSubmitClicked = function () {
      var _this2;

      return (_this2 = _this).__onSubmitClicked__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dialog, [{
    key: '__onSubmitClicked__REACT_HOT_LOADER__',
    value: function __onSubmitClicked__REACT_HOT_LOADER__() {
      return this.__onSubmitClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      //todo: I don't know if this is correct
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#container').addClass('disable-scroll');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#container').removeClass('disable-scroll');
    }
  }, {
    key: '__onSubmitClicked__REACT_HOT_LOADER__',
    value: function __onSubmitClicked__REACT_HOT_LOADER__() {
      this.setState({ submitted: true });
    }
  }, {
    key: 'renderBorder',
    value: function renderBorder(title) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'section-border web' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-title web info' },
          title
        )
      );
    }
  }, {
    key: 'renderInfoPopUp',
    value: function renderInfoPopUp(title, message) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'info-popup' },
        this.renderBorder(title),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'message' },
          message
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'button-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'button', onClick: this.props.handleExit },
            'Proceed'
          )
        )
      );
    }
  }, {
    key: 'renderEmailPopUp',
    value: function renderEmailPopUp() {
      var email = this.props.email ? this.props.email : '';
      var emailErr = this.props.emailErr ? this.props.emailErr : '';
      var pinErr = this.props.pinErr ? this.props.pinErr : '';

      var formFieldClassNames = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('form-field', {
        submitted: this.state.submitted
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'email-popup' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'cancel', onClick: this.props.handleExit }),
        this.renderBorder('Update Your Email Address'),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            {
              className: 'form',
              onSubmit: this.props.handleEditEmailSubmit,
              autoComplete: 'off'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'fieldset',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'legend',
                null,
                email
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: formFieldClassNames },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'New Email'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_widgets_ZElements__["a" /* ZInput */], {
                  className: 'form-input',
                  type: 'email',
                  ref: 'email',
                  error: 'A valid email is required.',
                  customError: emailErr,
                  required: true,
                  errorMessageVisible: true
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: formFieldClassNames },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Pin'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_widgets_ZElements__["a" /* ZInput */], {
                  className: 'form-input',
                  password: true,
                  type: 'tel',
                  ref: 'pin',
                  pattern: '\\d{6}',
                  maxLength: '6',
                  error: 'Pin must be exactly 6 digits',
                  customError: pinErr,
                  required: true,
                  errorMessageVisible: true
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-field center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                  className: 'button',
                  type: 'submit',
                  value: 'Update Email',
                  onClick: this.onSubmitClicked
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderErrorPopUp',
    value: function renderErrorPopUp(title, message) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'error-popup' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'title' },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'message' },
          message
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'button-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'button', onClick: this.props.handleExit },
            'Ok'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var body = void 0;
      switch (this.props.type) {
        case 'update-email':
          body = this.renderEmailPopUp();
          break;
        case 'complete-reg':
          body = this.renderInfoPopUp('Complete Your Registration', 'Please complete your registration by filling up the missing fields under "Personal Information"');
          break;
        case 'error':
          {
            var title = this.props.errTitle ? this.props.errTitle : '';
            var message = this.props.errMessage ? this.props.errMessage : '';
            body = this.renderErrorPopUp(title, message);
            break;
          }
        default:
          break;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'dialog' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'overlay' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          body
        )
      );
    }
  }]);

  return Dialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dialog.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  email: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  emailErr: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  pinErr: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  errTitle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  errMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  handleEditEmailSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  handleExit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
var _default = Dialog;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Dialog, 'Dialog', '/home/circleci/project/js/components/widgets/Dialog.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/widgets/Dialog.js');
}();

;

/***/ }),

/***/ 691:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_helpers_utils__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_merchant_wallet_banner_less__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_merchant_wallet_banner_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_merchant_wallet_banner_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MerchantWalletBanner = function (_React$Component) {
  _inherits(MerchantWalletBanner, _React$Component);

  function MerchantWalletBanner() {
    _classCallCheck(this, MerchantWalletBanner);

    return _possibleConstructorReturn(this, (MerchantWalletBanner.__proto__ || Object.getPrototypeOf(MerchantWalletBanner)).apply(this, arguments));
  }

  _createClass(MerchantWalletBanner, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'merchant-wallet-banner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'merchant' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'logo-info-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'logo' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: this.props.logo })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'info' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'name' },
                this.props.merchantName
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'branches' },
                this.props.numBranches,
                ' branches'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'points-info-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cleared-points-container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'points' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'value' },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_components_helpers_utils__["c" /* Comatose */])(this.props.clearedPoints)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'type' },
                  'points'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pending-points-container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'points' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'value' },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_components_helpers_utils__["c" /* Comatose */])(this.props.pendingPoints)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'type' },
                  'pending'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return MerchantWalletBanner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MerchantWalletBanner.propTypes = {
  logo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  merchantName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  numBranches: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  clearedPoints: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  pendingPoints: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
MerchantWalletBanner.defaultProps = {
  logo: 'https://s3-ap-southeast-1.amazonaws.com/assets.zap.com.ph//uploads/images/7bcb50a2-7f90-478c-b90d-46e2a3dbc4a5.jpeg',
  merchantName: 'Barcino',
  numBranches: 2,
  clearedPoints: 0,
  pendingPoints: 0
};
var _default = MerchantWalletBanner;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MerchantWalletBanner, 'MerchantWalletBanner', '/home/circleci/project/js/components/widgets/MerchantWalletBanner.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/widgets/MerchantWalletBanner.js');
}();

;

/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader__ = __webpack_require__(182);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PageLoader = function (_React$Component) {
	_inherits(PageLoader, _React$Component);

	function PageLoader() {
		_classCallCheck(this, PageLoader);

		return _possibleConstructorReturn(this, (PageLoader.__proto__ || Object.getPrototypeOf(PageLoader)).apply(this, arguments));
	}

	_createClass(PageLoader, [{
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: 'page-loader-container' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Loader__["a" /* default */], { loading: true })
			);
		}
	}]);

	return PageLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = PageLoader;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(PageLoader, 'PageLoader', '/home/circleci/project/js/components/widgets/PageLoader.js');

	__REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/components/widgets/PageLoader.js');
}();

;

/***/ }),

/***/ 693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ChangeEmailMutation = function (_Relay$Mutation) {
  _inherits(ChangeEmailMutation, _Relay$Mutation);

  function ChangeEmailMutation() {
    _classCallCheck(this, ChangeEmailMutation);

    return _possibleConstructorReturn(this, (ChangeEmailMutation.__proto__ || Object.getPrototypeOf(ChangeEmailMutation)).apply(this, arguments));
  }

  _createClass(ChangeEmailMutation, [{
    key: 'getVariables',
    value: function getVariables() {
      return {
        email: this.props.email,
        pin: this.props.pin
      };
    }
  }, {
    key: 'getConfigs',
    value: function getConfigs() {
      return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          auth: this.props.id
        }
      }];
    }
  }, {
    key: 'getFatQuery',
    value: function getFatQuery() {
      return function () {
        return {
          children: [{
            children: [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isRequisite: true
              },
              type: 'ID'
            }, {
              fieldName: 'email',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'isEmailConfirmed',
              kind: 'Field',
              metadata: {},
              type: 'Boolean'
            }],
            fieldName: 'auth',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Auth'
          }],
          id: __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'ChangeEmailMutationRelayQL',
          type: 'ChangeEmailPayload'
        };
      }();
    }
  }, {
    key: 'getMutation',
    value: function getMutation() {
      return function () {
        return {
          calls: [{
            kind: 'Call',
            metadata: {},
            name: 'changeEmail',
            value: {
              kind: 'CallVariable',
              callVariableName: 'input'
            }
          }],
          children: [{
            fieldName: 'clientMutationId',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'String'
          }],
          kind: 'Mutation',
          metadata: {
            inputType: 'ChangeEmailInput!'
          },
          name: 'ChangeEmailMutation',
          responseType: 'ChangeEmailPayload'
        };
      }();
    }
  }]);

  return ChangeEmailMutation;
}(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.Mutation);

var _default = ChangeEmailMutation;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ChangeEmailMutation, 'ChangeEmailMutation', '/home/circleci/project/js/mutations/ChangeEmailMutation.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/mutations/ChangeEmailMutation.js');
}();

;

/***/ }),

/***/ 694:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ChangePinMutation = function (_Relay$Mutation) {
  _inherits(ChangePinMutation, _Relay$Mutation);

  function ChangePinMutation() {
    _classCallCheck(this, ChangePinMutation);

    return _possibleConstructorReturn(this, (ChangePinMutation.__proto__ || Object.getPrototypeOf(ChangePinMutation)).apply(this, arguments));
  }

  _createClass(ChangePinMutation, [{
    key: 'getVariables',
    value: function getVariables() {
      return {
        oldPin: this.props.oldPin,
        newPin: this.props.newPin
      };
    }
  }, {
    key: 'getConfigs',
    value: function getConfigs() {
      return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          zapperId: this.props.zapperId
        }
      }];
    }
  }, {
    key: 'getFatQuery',
    value: function getFatQuery() {
      return function () {
        return {
          children: [{
            fieldName: 'zapperId',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'clientMutationId',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }],
          id: __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'ChangePinMutationRelayQL',
          type: 'ChangePinPayload'
        };
      }();
    }
  }, {
    key: 'getMutation',
    value: function getMutation() {
      return function () {
        return {
          calls: [{
            kind: 'Call',
            metadata: {},
            name: 'changePin',
            value: {
              kind: 'CallVariable',
              callVariableName: 'input'
            }
          }],
          children: [{
            fieldName: 'clientMutationId',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'String'
          }],
          kind: 'Mutation',
          metadata: {
            inputType: 'ChangePinInput!'
          },
          name: 'ChangePinMutation',
          responseType: 'ChangePinPayload'
        };
      }();
    }
  }]);

  return ChangePinMutation;
}(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.Mutation);

var _default = ChangePinMutation;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ChangePinMutation, 'ChangePinMutation', '/home/circleci/project/js/mutations/ChangePinMutation.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/mutations/ChangePinMutation.js');
}();

;

/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var LinkTagMutation = function (_Relay$Mutation) {
  _inherits(LinkTagMutation, _Relay$Mutation);

  function LinkTagMutation() {
    _classCallCheck(this, LinkTagMutation);

    return _possibleConstructorReturn(this, (LinkTagMutation.__proto__ || Object.getPrototypeOf(LinkTagMutation)).apply(this, arguments));
  }

  _createClass(LinkTagMutation, [{
    key: 'getVariables',
    value: function getVariables() {
      return {
        zapCode: this.props.zapCode,
        pin: this.props.pin
      };
    }
  }, {
    key: 'getConfigs',
    value: function getConfigs() {
      return [{
        type: 'REQUIRED_CHILDREN',
        children: [function () {
          return {
            children: [{
              children: [{
                children: [{
                  children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                      isRequisite: true
                    },
                    type: 'ID'
                  }],
                  fieldName: 'node',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true,
                    inferredRootCallName: 'node',
                    inferredPrimaryKey: 'id',
                    isRequisite: true
                  },
                  type: 'Membership'
                }, {
                  fieldName: 'cursor',
                  kind: 'Field',
                  metadata: {
                    isGenerated: true,
                    isRequisite: true
                  },
                  type: 'String'
                }],
                fieldName: 'edges',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  isPlural: true
                },
                type: 'MembershipEdge'
              }, {
                children: [{
                  fieldName: 'hasNextPage',
                  kind: 'Field',
                  metadata: {
                    isGenerated: true,
                    isRequisite: true
                  },
                  type: 'Boolean'
                }, {
                  fieldName: 'hasPreviousPage',
                  kind: 'Field',
                  metadata: {
                    isGenerated: true,
                    isRequisite: true
                  },
                  type: 'Boolean'
                }],
                fieldName: 'pageInfo',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'PageInfo'
              }],
              fieldName: 'memberships',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true
              },
              type: 'MembershipConnection'
            }],
            id: __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__id(),
            kind: 'Fragment',
            metadata: {},
            name: 'LinkTagMutation_ChildrenRelayQL',
            type: 'LinkTagPayload'
          };
        }()]
      }];
    }
  }, {
    key: 'getFatQuery',
    value: function getFatQuery() {
      return function () {
        return {
          children: [{
            children: [{
              children: [{
                children: [{
                  fieldName: 'id',
                  kind: 'Field',
                  metadata: {
                    isRequisite: true
                  },
                  type: 'ID'
                }, {
                  children: [{
                    fieldName: 'code',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }, {
                    fieldName: 'image',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                  }],
                  fieldName: 'tag',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true
                  },
                  type: 'Tag'
                }, {
                  children: [{
                    children: [{
                      fieldName: 'id',
                      kind: 'Field',
                      metadata: {
                        isRequisite: true
                      },
                      type: 'String'
                    }, {
                      fieldName: 'name',
                      kind: 'Field',
                      metadata: {},
                      type: 'String'
                    }, {
                      fieldName: 'cashBackRate',
                      kind: 'Field',
                      metadata: {},
                      type: 'BigDecimal'
                    }, {
                      fieldName: 'image',
                      kind: 'Field',
                      metadata: {},
                      type: 'String'
                    }],
                    fieldName: 'rank',
                    kind: 'Field',
                    metadata: {
                      canHaveSubselections: true
                    },
                    type: 'Rank'
                  }, {
                    fieldName: 'expiry',
                    kind: 'Field',
                    metadata: {},
                    type: 'Long'
                  }],
                  fieldName: 'activeRank',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true
                  },
                  type: 'ActiveRank'
                }, {
                  fieldName: 'image',
                  kind: 'Field',
                  metadata: {},
                  type: 'String'
                }],
                fieldName: 'node',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  inferredRootCallName: 'node',
                  inferredPrimaryKey: 'id',
                  isRequisite: true
                },
                type: 'Membership'
              }, {
                fieldName: 'cursor',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'String'
              }],
              fieldName: 'edges',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isPlural: true
              },
              type: 'MembershipEdge'
            }, {
              children: [{
                fieldName: 'hasNextPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }, {
                fieldName: 'hasPreviousPage',
                kind: 'Field',
                metadata: {
                  isGenerated: true,
                  isRequisite: true
                },
                type: 'Boolean'
              }],
              fieldName: 'pageInfo',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isGenerated: true,
                isRequisite: true
              },
              type: 'PageInfo'
            }],
            fieldName: 'memberships',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true
            },
            type: 'MembershipConnection'
          }],
          id: __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'LinkTagMutationRelayQL',
          type: 'LinkTagPayload'
        };
      }();
    }
  }, {
    key: 'getMutation',
    value: function getMutation() {
      return function () {
        return {
          calls: [{
            kind: 'Call',
            metadata: {},
            name: 'linkTag',
            value: {
              kind: 'CallVariable',
              callVariableName: 'input'
            }
          }],
          children: [{
            fieldName: 'clientMutationId',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'String'
          }],
          kind: 'Mutation',
          metadata: {
            inputType: 'LinkTagInput!'
          },
          name: 'LinkTagMutation',
          responseType: 'LinkTagPayload'
        };
      }();
    }
  }]);

  return LinkTagMutation;
}(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.Mutation);

var _default = LinkTagMutation;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LinkTagMutation, 'LinkTagMutation', '/home/circleci/project/js/mutations/LinkTagMutation.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/mutations/LinkTagMutation.js');
}();

;

/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ResendEmailVerificationMutation = function (_Relay$Mutation) {
  _inherits(ResendEmailVerificationMutation, _Relay$Mutation);

  function ResendEmailVerificationMutation() {
    _classCallCheck(this, ResendEmailVerificationMutation);

    return _possibleConstructorReturn(this, (ResendEmailVerificationMutation.__proto__ || Object.getPrototypeOf(ResendEmailVerificationMutation)).apply(this, arguments));
  }

  _createClass(ResendEmailVerificationMutation, [{
    key: 'getVariables',
    value: function getVariables() {
      return {};
    }
  }, {
    key: 'getConfigs',
    value: function getConfigs() {
      return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          zapperId: this.props.zapperId
        }
      }];
    }
  }, {
    key: 'getFatQuery',
    value: function getFatQuery() {
      return function () {
        return {
          children: [{
            fieldName: 'zapperId',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }],
          id: __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'ResendEmailVerificationMutationRelayQL',
          type: 'ResendEmailVerificationPayload'
        };
      }();
    }
  }, {
    key: 'getMutation',
    value: function getMutation() {
      return function () {
        return {
          calls: [{
            kind: 'Call',
            metadata: {},
            name: 'resendEmailVerification',
            value: {
              kind: 'CallVariable',
              callVariableName: 'input'
            }
          }],
          children: [{
            fieldName: 'clientMutationId',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'String'
          }],
          kind: 'Mutation',
          metadata: {
            inputType: 'ResendEmailVerificationInput!'
          },
          name: 'ResendEmailVerificationMutation',
          responseType: 'ResendEmailVerificationPayload'
        };
      }();
    }
  }]);

  return ResendEmailVerificationMutation;
}(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.Mutation);

var _default = ResendEmailVerificationMutation;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ResendEmailVerificationMutation, 'ResendEmailVerificationMutation', '/home/circleci/project/js/mutations/ResendEmailVerificationMutation.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/mutations/ResendEmailVerificationMutation.js');
}();

;

/***/ }),

/***/ 697:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var UpdateProfileMutation = function (_Relay$Mutation) {
  _inherits(UpdateProfileMutation, _Relay$Mutation);

  function UpdateProfileMutation() {
    _classCallCheck(this, UpdateProfileMutation);

    return _possibleConstructorReturn(this, (UpdateProfileMutation.__proto__ || Object.getPrototypeOf(UpdateProfileMutation)).apply(this, arguments));
  }

  _createClass(UpdateProfileMutation, [{
    key: 'getVariables',
    value: function getVariables() {
      var profile = this.props.profile;
      return {
        firstName: profile.firstName,
        lastName: profile.lastName,
        birthday: profile.birthday,
        gender: profile.gender,
        locationId: profile.locationId,
        streetAddress: profile.address
      };
    }
  }, {
    key: 'getConfigs',
    value: function getConfigs() {
      return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          profile: this.props.profile.id
        }
      }];
    }
  }, {
    key: 'getFatQuery',
    value: function getFatQuery() {
      return function () {
        return {
          children: [{
            children: [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isRequisite: true
              },
              type: 'ID'
            }, {
              fieldName: 'firstName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'lastName',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'birthday',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'gender',
              kind: 'Field',
              metadata: {},
              type: 'Gender'
            }, {
              fieldName: 'streetAddress',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'zipCode',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'locationId',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }],
            fieldName: 'profile',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Profile'
          }, {
            fieldName: 'clientMutationId',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }],
          id: __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'UpdateProfileMutationRelayQL',
          type: 'UpdateProfilePayload'
        };
      }();
    }
  }, {
    key: 'getMutation',
    value: function getMutation() {
      return function () {
        return {
          calls: [{
            kind: 'Call',
            metadata: {},
            name: 'updateProfile',
            value: {
              kind: 'CallVariable',
              callVariableName: 'input'
            }
          }],
          children: [{
            fieldName: 'clientMutationId',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'String'
          }],
          kind: 'Mutation',
          metadata: {
            inputType: 'UpdateProfileInput!'
          },
          name: 'UpdateProfileMutation',
          responseType: 'UpdateProfilePayload'
        };
      }();
    }
  }]);

  return UpdateProfileMutation;
}(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.Mutation);

var _default = UpdateProfileMutation;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UpdateProfileMutation, 'UpdateProfileMutation', '/home/circleci/project/js/mutations/UpdateProfileMutation.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/mutations/UpdateProfileMutation.js');
}();

;

/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var UpdateProfilePictureMutation = function (_Relay$Mutation) {
  _inherits(UpdateProfilePictureMutation, _Relay$Mutation);

  function UpdateProfilePictureMutation() {
    _classCallCheck(this, UpdateProfilePictureMutation);

    return _possibleConstructorReturn(this, (UpdateProfilePictureMutation.__proto__ || Object.getPrototypeOf(UpdateProfilePictureMutation)).apply(this, arguments));
  }

  _createClass(UpdateProfilePictureMutation, [{
    key: 'getFiles',
    value: function getFiles() {
      return {
        file: this.props.file
      };
    }
  }, {
    key: 'getVariables',
    value: function getVariables() {
      return {};
    }
  }, {
    key: 'getConfigs',
    value: function getConfigs() {
      return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          profile: this.props.profile.id
        }
      }];
    }
  }, {
    key: 'getFatQuery',
    value: function getFatQuery() {
      return function () {
        return {
          children: [{
            children: [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isRequisite: true
              },
              type: 'ID'
            }, {
              fieldName: 'image',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }],
            fieldName: 'profile',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Profile'
          }, {
            fieldName: 'clientMutationId',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }],
          id: __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'UpdateProfilePictureMutationRelayQL',
          type: 'UpdateProfilePicturePayload'
        };
      }();
    }
  }, {
    key: 'getMutation',
    value: function getMutation() {
      return function () {
        return {
          calls: [{
            kind: 'Call',
            metadata: {},
            name: 'updateProfilePicture',
            value: {
              kind: 'CallVariable',
              callVariableName: 'input'
            }
          }],
          children: [{
            fieldName: 'clientMutationId',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'String'
          }],
          kind: 'Mutation',
          metadata: {
            inputType: 'UpdateProfilePictureInput!'
          },
          name: 'UpdateProfilePictureMutation',
          responseType: 'UpdateProfilePicturePayload'
        };
      }();
    }
  }]);

  return UpdateProfilePictureMutation;
}(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.Mutation);

var _default = UpdateProfilePictureMutation;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UpdateProfilePictureMutation, 'UpdateProfilePictureMutation', '/home/circleci/project/js/mutations/UpdateProfilePictureMutation.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/mutations/UpdateProfilePictureMutation.js');
}();

;

/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MerchantRoute = function (_Relay$Route) {
  _inherits(MerchantRoute, _Relay$Route);

  function MerchantRoute() {
    _classCallCheck(this, MerchantRoute);

    return _possibleConstructorReturn(this, (MerchantRoute.__proto__ || Object.getPrototypeOf(MerchantRoute)).apply(this, arguments));
  }

  return MerchantRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.Route);

MerchantRoute.routeName = 'MerchantRoute';
MerchantRoute.paramDefinitions = {
  id: { required: true }
};
MerchantRoute.queries = {
  node: function node(Component) {
    return function (RQL_0) {
      return {
        calls: [{
          kind: 'Call',
          metadata: {
            type: 'ID!'
          },
          name: 'id',
          value: {
            kind: 'CallVariable',
            callVariableName: 'id'
          }
        }],
        children: [].concat.apply([], [{
          fieldName: 'id',
          kind: 'Field',
          metadata: {
            isGenerated: true,
            isRequisite: true
          },
          type: 'ID'
        }, {
          fieldName: '__typename',
          kind: 'Field',
          metadata: {
            isGenerated: true,
            isRequisite: true
          },
          type: 'String'
        }, __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__frag(RQL_0)]),
        fieldName: 'node',
        kind: 'Query',
        metadata: {
          isAbstract: true,
          identifyingArgName: 'id',
          identifyingArgType: 'ID!'
        },
        name: 'MerchantRoute',
        type: 'Node'
      };
    }(Component.getFragment('node'));
  }
};
var _default = MerchantRoute;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MerchantRoute, 'MerchantRoute', '/home/circleci/project/js/routes/MerchantRoute.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/routes/MerchantRoute.js');
}();

;

/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ResetPinSessionRoute = function (_Relay$Route) {
  _inherits(ResetPinSessionRoute, _Relay$Route);

  function ResetPinSessionRoute() {
    _classCallCheck(this, ResetPinSessionRoute);

    return _possibleConstructorReturn(this, (ResetPinSessionRoute.__proto__ || Object.getPrototypeOf(ResetPinSessionRoute)).apply(this, arguments));
  }

  return ResetPinSessionRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.Route);

ResetPinSessionRoute.routeName = 'ResetPinSessionRoute';
ResetPinSessionRoute.queries = {
  resetPinSession: function resetPinSession(Component) {
    return function (RQL_0) {
      return {
        children: [].concat.apply([], [{
          fieldName: 'id',
          kind: 'Field',
          metadata: {
            isGenerated: true,
            isRequisite: true
          },
          type: 'ID'
        }, __WEBPACK_IMPORTED_MODULE_0_react_relay_classic___default.a.QL.__frag(RQL_0)]),
        fieldName: 'resetPinSession',
        kind: 'Query',
        metadata: {},
        name: 'ResetPinSessionRoute',
        type: 'ResetPinSession'
      };
    }(Component.getFragment('resetPinSession'));
  }
};
var _default = ResetPinSessionRoute;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ResetPinSessionRoute, 'ResetPinSessionRoute', '/home/circleci/project/js/routes/ResetPinSessionRoute.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/home/circleci/project/js/routes/ResetPinSessionRoute.js');
}();

;

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return APP_STORE_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PLAY_STORE_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GOOGLE_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PH_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USA_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SG_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MY_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VN_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return INTERCOM_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GOOGLE_ANALYTICS_TRACKING_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GOOGLE_CONVERSION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GOOGLE_CONVERSION_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ZAP_DEALS_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return E_STORE_LINK; });
/* unused harmony export LOYALTY_EXPRESS_SIGNUP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PH_BUSINESS_HOST; });
var GOOGLE_API_KEY = "AIzaSyDZJM93o8cwabh3h2K4FerQHRZ9f0-h58Y";
var PH_HOST = "customer.staging.zap.com.ph";
var USA_HOST = "www.staging.zaployalty.com";
var SG_HOST = "sg.staging.zaployalty.com";
var MY_HOST = "my.staging.zaployalty.com";
var VN_HOST = "vn.staging.zaployalty.com";
var ZAP_DEALS_LINK = "https://zap-deals-ph-qa1.myshopify.com";
var E_STORE_LINK = "https://qa.estore.z4p.me/";
var INTERCOM_APP_ID = "nr8niow0";
var GOOGLE_ANALYTICS_TRACKING_ID = "UA-37253735-1";
var GOOGLE_CONVERSION_ID = "1037596324";
var GOOGLE_CONVERSION_LABEL = "GAYPCJXeuWsQpO3h7gM";
var LOYALTY_EXPRESS_SIGNUP = "https://loyalty.qa.z4p.me/signup";
var PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=ph.com.zap.android";
var APP_STORE_LINK = "https://itunes.apple.com/ph/app/zap-philippines/id907381118";
var PH_BUSINESS_HOST = "https://business.staging.zap.com.ph";

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GOOGLE_API_KEY, "GOOGLE_API_KEY", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(PH_HOST, "PH_HOST", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(USA_HOST, "USA_HOST", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(SG_HOST, "SG_HOST", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(MY_HOST, "MY_HOST", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(VN_HOST, "VN_HOST", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(ZAP_DEALS_LINK, "ZAP_DEALS_LINK", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(E_STORE_LINK, "E_STORE_LINK", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(INTERCOM_APP_ID, "INTERCOM_APP_ID", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(GOOGLE_ANALYTICS_TRACKING_ID, "GOOGLE_ANALYTICS_TRACKING_ID", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(GOOGLE_CONVERSION_ID, "GOOGLE_CONVERSION_ID", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(GOOGLE_CONVERSION_LABEL, "GOOGLE_CONVERSION_LABEL", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(LOYALTY_EXPRESS_SIGNUP, "LOYALTY_EXPRESS_SIGNUP", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(PLAY_STORE_LINK, "PLAY_STORE_LINK", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(APP_STORE_LINK, "APP_STORE_LINK", "/home/circleci/project/config/config.staging.js");

  __REACT_HOT_LOADER__.register(PH_BUSINESS_HOST, "PH_BUSINESS_HOST", "/home/circleci/project/config/config.staging.js");
}();

;

/***/ }),

/***/ 794:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 795:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 796:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 797:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 799:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 801:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 802:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 803:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 804:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 805:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 806:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 807:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 808:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 809:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 810:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 811:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 812:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "js/components/images/applestore_white-9739a6e4428502dd35360e21ee736199.svg";

/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "js/components/images/dark_fb-a0624513c34d7f85d312e986434d051d.svg";

/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "js/components/images/dark_insta-2a22148a345fbd259f10ae1d20ba2af9.svg";

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "js/components/images/flag-malaysia-f4c8adad63dc13c676fc5bada6c17f85.png";

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "js/components/images/flag-philippines-3d7dd60c10866744cbbdbd8148984bfc.png";

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "js/components/images/google_play_white-d31c1a6fba47e6d69698acd96d233148.svg";

/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "js/components/images/zap_logo_loyalty_white-e15050430cfa215743c6879017ab7189.svg";

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "js/components/images/zapcash-7eb96b0cff0ce1bc9bd496cf61d0b7b2.svg";

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Comatose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TimeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DateTimeFormat; });
/* unused harmony export ToUrlFormat */
/* unused harmony export LinkState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleChange; });
/* unused harmony export mapPricingTableData */
/* unused harmony export mq */
/* unused harmony export useMq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_useMediaQuery__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_useMediaQuery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_useMediaQuery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(681);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function Comatose(s) {
  return s.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function DateFormat(s) {
  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  var d = new Date(s);

  return months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
}

function TimeFormat(s) {
  var d = new Date(s);
  return d.toLocaleTimeString();
}

function DateTimeFormat(s) {
  var d = new Date(s);
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(d.toString()).format("MMMM D, YYYY h:mm A");
}

function ToUrlFormat(str) {
  return str.replace(/\W+/g, "-").toLowerCase();
}

function LinkState(self, fieldName) {
  return {
    value: self.state[fieldName],
    requestChange: function requestChange(newValue) {
      var delta = {};
      delta[fieldName] = newValue;
      self.setState(delta);
    }
  };
}

function handleChange(e) {
  var transformer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (value) {
    return value;
  };

  e.preventDefault();
  var _e$target = e.target,
      value = _e$target.value,
      name = _e$target.name;

  if (name) this.setState(_defineProperty({}, name, transformer(value)));
}

function mapPricingTableData(tier, pricingTableData) {
  return {
    header: _defineProperty({}, tier, pricingTableData.header[tier]),
    footer: _defineProperty({}, tier, pricingTableData.footer[tier]),
    sections: pricingTableData.sections.map(function (s) {
      return {
        title: s.title,
        rows: s.rows.map(function (sr) {
          return {
            title: sr.title,
            value: _defineProperty({}, tier, sr.value[tier])
          };
        })
      };
    })
  };
}

var mq = function mq(breakpoint) {
  return "@media (min-width: " + __WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* breakpoints */].values[breakpoint] + "px)";
};

var useMq = function useMq(breakpoint) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_useMediaQuery__["unstable_useMediaQuery"])(mq(breakpoint));
};


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Comatose, "Comatose", "/home/circleci/project/js/components/helpers/utils.js");

  __REACT_HOT_LOADER__.register(DateFormat, "DateFormat", "/home/circleci/project/js/components/helpers/utils.js");

  __REACT_HOT_LOADER__.register(TimeFormat, "TimeFormat", "/home/circleci/project/js/components/helpers/utils.js");

  __REACT_HOT_LOADER__.register(DateTimeFormat, "DateTimeFormat", "/home/circleci/project/js/components/helpers/utils.js");

  __REACT_HOT_LOADER__.register(ToUrlFormat, "ToUrlFormat", "/home/circleci/project/js/components/helpers/utils.js");

  __REACT_HOT_LOADER__.register(LinkState, "LinkState", "/home/circleci/project/js/components/helpers/utils.js");

  __REACT_HOT_LOADER__.register(handleChange, "handleChange", "/home/circleci/project/js/components/helpers/utils.js");

  __REACT_HOT_LOADER__.register(mapPricingTableData, "mapPricingTableData", "/home/circleci/project/js/components/helpers/utils.js");

  __REACT_HOT_LOADER__.register(mq, "mq", "/home/circleci/project/js/components/helpers/utils.js");

  __REACT_HOT_LOADER__.register(useMq, "useMq", "/home/circleci/project/js/components/helpers/utils.js");
}();

;

/***/ })

},[677]);


// WEBPACK FOOTER //
// app.js